/* global jQuery */

jQuery.noConflict();
(function ($) {

	/*
	* jquery-match-height 0.7.2 by @liabru
	* http://brm.io/jquery-match-height/
	* License MIT
	*/
	!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,n=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),i=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-n(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(i-a))<=o?r[r.length-1]=s.add(e):r.push(e),i=a}),r},i=function(e){var o={
	byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=i(e);if(o.remove){var n=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(n)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.2",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
	r._afterUpdate=null,r._rows=a,r._parse=n,r._parseOptions=i,r._apply=function(e,o){var s=i(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),u=h.parents().filter(":hidden");return u.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),u.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
	"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),i=0;if(s.target)i=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),n=e.css("display");"inline-block"!==n&&"flex"!==n&&"inline-flex"!==n&&(n="block");var a={
	display:n};a[s.property]="",e.css(a),e.outerHeight(!1)>i&&(i=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=n(e.css("border-top-width"))+n(e.css("border-bottom-width")),o+=n(e.css("padding-top"))+n(e.css("padding-bottom"))),e.css(s.property,i-o+"px"))})}),u.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
	this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),n=o.attr("data-mh")||o.attr("data-match-height");n in e?e[n]=e[n].add(o):e[n]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(n,a){if(a&&"resize"===a.type){var i=t(window).width();if(i===e)return;e=i;
	}n?o===-1&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi);var h=t.fn.on?"on":"bind";t(window)[h]("load",function(t){r._update(!1,t)}),t(window)[h]("resize orientationchange",function(t){r._update(!0,t)})});

	//jQuery.noConflict();
	//(function( $ ) {
	
	// ================
	// L A Z Y L O A D
	// ================
	
	//$.lazyLoadXT.autoInit=false;
	
	
		$.extend($.lazyLoadXT, {
			//autoInit: false,
			//visibleOnly: false,
			oninit: {addClass: 'lazy'},
			onload: {removeClass: 'lazy', addClass: 'lazy-loaded'}
		});
	
		var options = $.lazyLoadXT,
			bgAttr = options.bgAttr || 'data-bg';
	
			options.selector += ',[' + bgAttr + ']';
	
			$(document).on('lazyshow', function (e) {
				var $this = $(e.target);
	
				if(!$this.data('lazyshow')){
					$this.data('lazyshow', true);
	
					// BACKGROUND
					if ($this.is("["+bgAttr+"]")) {
						var bgImageSrc = $this.attr(bgAttr);
						$('<img/>').attr('src', bgImageSrc).load(function() {
						    $(this).remove();
							$this.css('background-image', "url('" + bgImageSrc + "')")
								.removeAttr(bgAttr)
								.addClass('lazy-loaded');
						});
					}
				}
			});
	
			$(document).on('lazyload', function (e) {
				var $this = $(e.target);
			});
	
			$('img[data-src]').each(function(i) {
				var img = $(this);
	
				if(!img.parents('.carousel').length){
					if(img.attr('width') && img.attr('height')) {
						//console.log('lazy: '+img.attr('width')+' x '+img.attr('height'));
						//img.attr('src','data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
						img.css('padding-bottom',(img.attr('height')/img.attr('width')*100-0)+'%');
					}
				}
			});
	//})(jQuery);
	
	function Main() {}
	
	Main.prototype = {
		constructor: Main,
	
		initSite: function () {
			// DEBUGGER
	
			if (
				location.href.indexOf(".devlocal") > 0 ||
				location.href.indexOf(".xip.io") > 0
			) {
				$("body").append($('<div class="mobile-debugger"></div>'));
				$("body").addClass("showDebug");
				$(".mobile-debugger").addClass("showDebug");
			}
	
			$(window).bind("resize orientationchange", function () {
				var html = $("html");
	
				//if($('html.no-touch').length || isDesktop){
				//isDesktop = true;
				if (Modernizr.mq("(max-width: " + breakPoints.desktop + "px)")) {
					html.addClass("touch until-desktop").removeClass("no-touch");
				} else {
					html.removeClass("touch until-desktop").addClass("no-touch");
				}
				if (Modernizr.mq("(max-width: " + breakPoints.tablet + "px)")) {
					html.addClass("until-tablet");
				} else {
					html.removeClass("until-tablet");
				}
				if (Modernizr.mq("(max-width: " + breakPoints.tabletLandscape + "px)")) {
					html.addClass("until-tabletLandscape");
				} else {
					html.removeClass("until-tabletLandscape");
				}
				if (Modernizr.mq("(min-width: " + breakPoints.tablet + "px)")) {
					html.addClass("from-tablet");
				} else {
					html.removeClass("from-tablet");
				}
				//}
			});
	
			// SCROLLMAGIC
	
			if (!$("html.lt-ie9").length) {
				scrollController = new ScrollMagic.Controller();
				$(window).bind("resize orientationchange", function () {
					scrollController.update(true);
				});
			}
	
			// onScreen
			var os = new OnScreen();
			os.on("enter", ".js-on-screen", function (element) {
				$(element).addClass("is-on-screen");
			});
	
			// Rellax
			setTimeout(function () {
				if ($(".js-parallax").length) {
					var rellax = new Rellax(".js-parallax");
				}
			}, 1000);
	
			Main.objects.preloader = new preloader();
			Main.objects.smoothScroll = new smoothScroll();
		},
		initPlugins: function (scope) {
			scope.find(".nav-main").each(function () {
				new navMain($(this)).init();
			});
	
			scope.find(".js-nav-language").each(function () {
				new navLanguage($(this)).init();
			});
	
			scope.find(".hero").each(function () {
				new hero($(this)).init();
			});
	
			scope.find(".js-kern").each(function () {
				new kernOverlay($(this)).init();
			});
	
			scope.find(".js-image-archive").each(function () {
				new imageArchive($(this)).init();
			});
	
			scope.find(".js-image-archive__swiper").each(function () {
				new imageArchiveSwiper($(this)).init();
			});
	
			scope.find("a[href*='youtu'], *[data-src*='youtu']").each(function () {
				var $a = $("a", $(this)).length ? $("a", $(this)) : $(this);
				var src = $(this).attr("href")
					? $(this).attr("href")
					: $(this).data("src");
				var videoId = src.match(
					/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/
				);
				if (videoId) {
					$a.attr("href", src);
					new videoView($a).init();
				}
			});
	
			scope.find(".teaser-grid__swiper").each(function () {
				new teaserGridSwiper($(this)).init();
			});
			scope.find(".headlines__swiper").each(function () {
				new headlinesSwiper($(this)).init();
			});
	
			scope.find(".bricks").each(function () {
				new Bricks($(this)).init();
			});
	
			scope.find(".bubble-grid").each(function () {
				new bubbleGrid($(this)).init();
			});
	
			scope.find(".count-up").each(function (i, e) {
				$self = $(this);
	
				var from = 0;
				var text = $self.text();
	
				var to = parseFloat(text.replace(",", "."));
				var fl = $self.text().indexOf(".");
	
				var cnt = new CountUp($self[0], from, to, fl > 0 ? 1 : 0, 2.5, {
					useEasing: true,
					useGrouping: true,
					decimal: Main.getLang() == "en" ? "." : ",",
					separator: "",
				});
				var scene = new ScrollMagic.Scene({
					triggerElement: e,
					triggerHook: "onEnter",
					offset: 100,
					reverse: false,
				})
					.on("enter", function (e) {
						cnt.start();
					})
					.addTo(scrollController);
			});
	
			scope.find(".mobile-swiper").each(function () {
				new mobileSwiper($(this)).init();
			});
	
			scope.find(".js-faq").each(function () {
				new faq($(this));
			});
	
			scope.find(".js-accordion").each(function () {
				new accordion($(this));
			});
	
			scope.find(".js-filter").each(function () {
				new filter($(this));
			});
	
			var scrollSidebar = 0;
			scope.find(".js-sidebar-menu").each(function () {
				this.sidebarMenu = new sidebarMenu($(this));
				scrollSidebar++;
			});
			if (scrollSidebar !== 0) {
				$(document).on("scroll", function () {
					$(document).trigger("stickyNavbarScroll");
				});
			}
	
			if (scope.find(".js-nav-page").length > 0) {
				$(document).on("scroll", function () {
					Main.siteHeaderFix();
				});
			}
	
			scope.find(".js-sticky").each(function () {
				$(this).stick_in_parent();
			});
	
			scope.find(".js-nice-select").each(function () {
				new niceSelect($(this));
			});
	
			scope.find(".js-nice-checkbox").each(function () {
				new NiceCheckbox($(this));
			});
	
			scope.find(".js-nice-search").each(function () {
				new NiceSearch($(this));
			});
	
			scope.find(".js-center-list").each(function () {
				new centerList($(this));
			});
	
			scope.find(".js-download-list").each(function () {
				new downloadList($(this));
			});
	
			scope.find(".js-timeline").each(function () {
				new Timeline($(this));
			});
	
			scope.find(".js-nav-page").each(function () {
				new PageNav($(this));
			});
	
			scope.find("section.voices").each(function () {
				new Voices($(this));
			});
	
			scope.find(".js-init-vertical-list").each(function () {
				new VerticalList($(this));
			});
	
			scope.find(".list-grid").each(function () {
				new ListGrid($(this));
			});
	
			scope.find("section.tabs").each(function () {
				new Tabs($(this));
			});
	
			scope.find('a[overlay="true"]').each(function () {
				new Overlay($(this));
			});
	
			scope.find("section.gallery").each(function () {
				new Gallery($(this));
			});
	
			//HERO VIDEO
			scope.find("section.hero__video__wrapper").each(function () {
				new heroVideo($(this));
			});
	
			scope.find("section.teaser-landing-map").each(function () {
				new landingMap($(this));
			});
	
			scope.find(".js-contact-form").each(function () {
				new contactForm($(this));
			});
	
			scope.find(".js-career-finder").each(function () {
				new careerFinder($(this));
			});
	
			scope.find(".js-cookie-header").each(function () {
				new cookieHeader($(this));
			});
	
			scope.find(".js-portfolioMap").each(function () {
				new portfolioMap($(this));
			});
	
			scope.find(".js-portfolioList").each(function () {
				new portfolioList($(this));
			});
	
			scope.find(".js-portfolioTeaser").each(function () {
				new portfolioTeaser($(this));
			});
	
			scope.find(".js-iconGrid").each(function () {
				new iconGrid($(this));
			});
	
			scope.find(".kontakt-block--container").each(function () {
				$(this).find(".kontakt-block").matchHeight({
					byRow: true,
					property: "height",
					target: null,
					remove: false,
				});
			});
		},
		init: function () {
			Main.objects = {};
			Main.initSite();
			Main.initPlugins($(document));
			$(window).trigger("resize");
			Main.siteHeaderFix();
		},
		siteHeaderFix: function () {
			if ($(".js-nav-page").length > 0 && $(".hero").length > 0) {
				var scrollOffsetInclHeaderHeight =
					$(document).scrollTop() + $(".site-header").height();
				var fixedHeaderAcnhor = $(".js-nav-page").offset().top;
	
				if (
					scrollOffsetInclHeaderHeight > fixedHeaderAcnhor &&
					!$(".site-header").hasClass("site-header--page-nav-stop")
				) {
					$(".site-header")
						.addClass("site-header--page-nav-stop")
						.css(
							"top",
							$(".hero").offset().top +
								$(".hero").height() -
								2 * $(".site-header").height()
						);
				} else if (
					scrollOffsetInclHeaderHeight < fixedHeaderAcnhor &&
					$(".site-header").hasClass("site-header--page-nav-stop")
				) {
					$(".site-header")
						.removeClass("site-header--page-nav-stop")
						.removeAttr("style");
				}
			}
		},
	
		getLang: function () {
			var lang = $(location).attr("pathname");
			lang.indexOf(1);
			lang.toLowerCase();
			lang = lang.split("/")[1];
			return lang;
		},
	};
	
	var breakPoints = {
		mobile: 320,
		mobileLandscape: 480,
		tablet: 740,
		desktopAd: 810,
		tabletLandscape: 906,
		desktop: 980,
		desktopEx: 1025,
		wide: 1200,
		full: 1300,
	};
	
	var translate = function (key) {
		const script = document.getElementById("project-config");
		const projectConfig = JSON.parse(script.textContent);
		const translations = projectConfig.translations;
		return translations[key] || key;
	};
	
	var swiperA11yOptions = {
		enabled: true,
	};
	Object.assign(swiperA11yOptions, translate("slider"));
	
	var sanitizeId = function (id) {
		return id.replace(/[^a-z0-9]/gi, "");
	};
	
	var isDesktop;
	var Main = new Main();
	
	$(Main.init);
	
	function navMain($el) {
		this.$el = $el;
		this.$icon = $('.nav-main-icon');
	};
	navMain.prototype = {
		constructor: navMain,
	
		initView: function() {},
		initPlugins: function() {},
		initListeners: function() {
			var t = this;
			this.$icon.bind('click', function(e) {
				$('header').toggleClass('nav-main--open');
			});
		},
		init: function() {
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	};
	
	function navLanguage($el) {
		this.$el = $el;
		this.$current = $el.find(".js-nav-language__current");
		this.$dropdown = $el.find(".js-nav-language__dropdown");
		this.$countryselect = $el.find(".js-browserlang-select");
		this.dropdownOpen = false;
	}
	navLanguage.prototype = {
		constructor: navLanguage,
	
		initListeners: function () {
			this.$current.on("click", { self: this }, this.currentClickHandler);
			$(document).on("click", { self: this }, this.documentClickHandler);
	
			this.$countryselect.on("click", function () {
				var userLang = navigator.language || navigator.userLanguage;
				userLang = userLang.split("-")[0];
	
				if (
					$(this)
						.parents(".nav-language__item")
						.find('a[data-lang="' + userLang + '"]').length > 0
				) {
					var href = $(this)
						.parents(".nav-language__item")
						.find('a[data-lang="' + userLang + '"]')
						.attr("href");
				} else if (
					$(this).parents(".nav-language__item").find('a[data-lang="en"]')
						.length > 0
				) {
					var href = $(this)
						.parents(".nav-language__item")
						.find('a[data-lang="en"]')
						.attr("href");
				} else {
					var href = $(this)
						.parents(".nav-language__item")
						.find(".nav-language__item__links a")
						.first()
						.attr("href");
				}
	
				window.location.href = href;
			});
		},
	
		documentClickHandler: function (e) {
			var self = e.data.self;
			if (self.dropdownOpen && !$(event.target).closest(self.$el).length) {
				self.toggleDropdown();
			}
		},
	
		currentClickHandler: function (e) {
			var self = e.data.self;
			self.toggleDropdown();
		},
	
		toggleDropdown: function () {
			this.dropdownOpen = !this.dropdownOpen;
			this.$el.toggleClass("has-language-dropdown");
			this.$current.attr("aria-expanded", this.dropdownOpen);
			this.$dropdown.attr("aria-hidden", !this.dropdownOpen);
			if (this.dropdownOpen) {
				this.$dropdown.removeAttr("inert");
			} else {
				this.$dropdown.attr("inert", "");
			}
		},
	
		init: function () {
			this.initListeners();
		},
	};
	
	function hero($el) {
		this.$el = $el;
	};
	hero.prototype = {
		constructor: hero,
	
		initView: function() {
			// $('h1, h2', this.$el).each(function() {
			// 	var self = $(this);
			// 	var html = self.text();
			// 	html = '<span>' + html.split(' ').join(' </span><span>') + ' </span>';
			// 	self.empty().html(html);
			// });
		},
		initPlugins: function() {},
		initListeners: function() {},
		init: function() {
			this.initView();
			this.initListeners();
			this.initPlugins();
		}
	};
	
	function videoView($el) {
		this.$el = $el;
	
		this.videoPlayer;
		this.playerId = "player_" + Math.ceil(Math.random() * 1000000000000000000000);
		// this.playerId			= 'player_' + 'player_not_so_unique_id';
		this.$video = this.$el.parents(".video__player");
		this.$embed = $(".video__embed", this.$video);
		this.$closeBtn = $(".video--hero__close");
		this.$expandedControlButtons = $(
			'[aria-controls="' + this.$closeBtn.attr("aria-controls") + '"]'
		);
		this.videoInline = this.$el.hasClass("video--inline");
		if (!this.videoInline) {
			this.playerId = "player_overlayplayer";
		}
		this.videoDelay = this.$el.data("video-delay")
			? parseFloat(this.$el.data("video-delay"))
			: 0;
		this.playState;
	
		window.youTubeAPIReady;
	
		this.isBtn = this.$el.is("a");
		this.videoUrl = this.isBtn
			? this.$el.attr("href")
			: this.$el.data("video-url");
		this.videoId = this.isBtn
			? this.$el
					.attr("href")
					.match(
						/^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/
					)
			: this.$el.data("video-id");
		this.videoId =
			this.videoId && typeof this.videoId === "object"
				? this.videoId.pop()
				: this.videoId;
		this.html5 = this.videoUrl && this.videoUrl.indexOf(".mp4") > 0;
		this.closing;
	
		this.autoInit = this.$el.hasClass("video--init-onload");
		this.$popup;
		this.$popupInner;
		this.$overlay = $('<div class="video-overlay"></div>');
		this.$close = $(
			'<button class="video-close" aria-label="' +
				translate("close") +
				'"></button>'
		);
		this.$tpl = $(
			'<div class="video-outer" style="display: none;">\
										<div class="video-overlay"></div>\
										<div class="video__wrapper">\
											<div class="video__inner">\
												<div class="video__body">\
													<div id="' +
				this.playerId +
				'"></div>\
												</div>\
											</div>\
										</div>\
										<div class="video-close"></div>\
									</div>'
		);
	}
	
	videoView.prototype = {
		constructor: videoView,
	
		initView: function () {
			var that = this;
			this.$embed.attr("id", this.playerId);
		},
		convertYouTubeDuration: function (input) {
			var reptms = /^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/;
			var hours = 0,
				minutes = 0,
				seconds = 0,
				totalseconds;
	
			if (reptms.test(input)) {
				var matches = reptms.exec(input);
				if (matches[1]) hours = Number(matches[1]);
				if (matches[2]) minutes = Number(matches[2]);
				if (matches[3]) seconds = Number(matches[3]);
				totalseconds = hours * 3600 + minutes * 60 + seconds;
			}
			return totalseconds;
		},
		initPlugins: function () {
			var that = this;
	
			if (!this.isBtn && this.videoId) {
				setTimeout(function () {
					that.videoPlayerPrepare();
					that.videoOpen();
				}, that.videoDelay * 1000);
			}
		},
		initListeners: function () {
			var that = this;
	
			if (this.isBtn) this.$el.on("click", this.onClick.bind(this));
		},
		onClick: function (e) {
			e.preventDefault();
			if (this.videoId || this.html5) {
				var $clicked = $(e.currentTarget);
	
				if (
					this.isBtn &&
					!$clicked.hasClass("video-close") &&
					!$clicked.hasClass("video-overlay")
				) {
					this.videoPlayerPrepare();
					this.videoOpen();
				} else {
					this.videoClose();
				}
			}
		},
		videoOpen: function (content) {
			var that = this;
	
			if (that.$popup && !that.$popup.hasClass("show")) {
				that.$popup.show();
	
				setTimeout(function () {
					that.$popup.addClass("show");
				}, 0);
	
				setTimeout(function () {
					that.$popup.removeClass("stop");
				}, 600);
			}
	
			console.log(window.videoPlayer);
			if (window.videoPlayer !== undefined) {
				window.videoPlayer.loadVideoById(this.videoId);
				// that.videoPlayerInit();
			} else {
				console.log("ELSE");
				clearInterval(that.closing);
				that.closing = setInterval(function () {
					if (window.youTubeAPIReady) {
						clearInterval(that.closing);
						setTimeout(function () {
							that.videoPlayerInit();
						}, 500);
					}
				}, 30);
			}
		},
	
		videoClose: function () {
			var that = this;
	
			$("html").data("video-playing", "");
	
			this.$expandedControlButtons.attr("aria-expanded", "false");
	
			if ($(".video__player--hero.video--playing").length) {
				if (window.videoPlayer) window.videoPlayer.pauseVideo();
			} else if (this.$popup && this.$popup.hasClass("show")) {
				this.$popup.removeClass("show playing");
	
				clearInterval(that.closing);
				that.closing = setInterval(function () {
					if (window.videoPlayer || that.html5) {
						clearInterval(that.closing);
						if (window.videoPlayer) window.videoPlayer.pauseVideo();
	
						setTimeout(function () {
							that.stopVideo();
							that.$popup.hide();
						}, 1000);
					}
				}, 30);
	
				if (typeof scrollController !== "undefined") {
					scrollController.enabled(true);
					scrollController.update(true);
				}
			}
		},
	
		videoPlayerPrepare: function () {
			var that = this;
	
			// console.log('videoPlayerPrepare');
	
			$("body").data("videoView", this);
	
			$(".site-header a")
				.unbind("click.videoView")
				.bind("click.videoView", function () {
					that.stopVideo();
				});
	
			if (!window.youTubeAPIReady && !this.html5) {
				var tag = $("<script></script>");
				tag.attr("src", "https://www.youtube.com/iframe_api");
				$("body").append(tag);
	
				window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady;
			}
	
			if (!$(".video-outer").length && !this.videoInline) {
				$("body").prepend(this.$tpl.clone());
			}
	
			if (!this.videoInline) {
				if (!this.$popup) {
					this.$popup = $(".video-outer");
					this.$close = $(".video-close", this.$popup);
					this.$overlay = $(".video-overlay", this.$popup);
				}
				this.$close.off().on("click", this.onClick.bind(this));
				this.$overlay.off().on("click", this.onClick.bind(this));
			} else {
				this.$video.addClass("video--prepare");
			}
		},
	
		videoPlayerInit: function () {
			var $player = $("#" + this.playerId);
	
			window.videoPlayer = new YT.Player(this.playerId, {
				height: "100%",
				width: "100%",
				videoId: this.videoId,
				//wmode: 'transparent',
				events: {
					onReady: this.onYouTubePlayerReady.bind(this),
					onStateChange: this.onYouTubePlayerStateChange.bind(this),
				},
				playerVars: {
					autohide: 1,
					autoplay: 1,
					wmode: "opaque",
					enablejsapi: 1,
					controls: this.controls ? 0 : 2,
					color: "red",
					modestbranding: 1,
					showinfo: 1,
					fs: 1,
					rel: 0,
					playsinline: 0,
				},
			});
	
			$("html").data("video-playing", this.videoPlayer);
		},
	
		onYouTubeIframeAPIReady: function () {
			if (!window.youTubeAPIReady) {
				window.youTubeAPIReady = true;
			}
		},
	
		onYouTubePlayerReady: function (event) {
			console.log("onYouTubePlayerReady");
			/*event.target.playVideo();
			event.target.loadVideoById(this.videoId);
			if(!$('#'+this.playerId).data('ie-debug')){
				$('#'+this.playerId).data('ie-debug','1');
				$('#'+this.playerId).attr('wmode','opaque').attr('allowtransparency','true');
			}*/
		},
	
		onYouTubePlayerStateChange: function (event) {
			var that = this,
				timer,
				duration;
			console.log(event.data);
			//console.log('onYouTubePlayerStateChange: '+event.data);
			if (event.data == YT.PlayerState.PAUSED && this.playState != "PAUSED") {
				//console.log('VIDEO -- PAUSED');
				this.playState = "PAUSED";
			}
			if (event.data == YT.PlayerState.PLAYING && this.playState != "PLAYING") {
				//console.log('VIDEO -- PLAYING');
				this.playState = "PLAYING";
				$("html").data("video-playing", window.videoPlayer);
	
				if (this.$popup) {
					this.$popup.addClass("playing");
	
					duration = window.videoPlayer.getDuration();
					timer = setInterval(function () {
						if (duration - 1.5 - window.videoPlayer.getCurrentTime() < 0) {
							clearInterval(timer);
							that.videoClose();
						}
					}, 0);
				}
				if (this.videoInline) {
					this.$video.addClass("video--playing");
	
					if (!this.videoPlayer) return;
	
					duration = this.videoPlayer.getDuration();
	
					timer = setInterval(function () {
						if (duration - 1 - window.videoPlayer.getCurrentTime() < 0) {
							clearInterval(timer);
							that.$video.removeClass("video--playing").addClass("video--ended");
						}
						if (
							$("html").data("video-playing") != window.videoPlayer &&
							that.playState == "PLAYING"
						) {
							window.videoPlayer.pauseVideo();
						}
					}, 0);
				}
			}
			if (
				event.data == YT.PlayerState.BUFFERING &&
				this.playState != "BUFFERING"
			) {
				//console.log('VIDEO -- BUFFERING');
				this.playState = "BUFFERING";
				if (this.$popup) this.$popup.addClass("buffering");
				if (this.videoInline) {
					this.$video.addClass("video--playing");
				}
			}
			if (event.data == YT.PlayerState.ENDED && this.playState != "ENDED") {
				//console.log('VIDEO -- ENDED');
				this.playState = "ENDED";
				if (this.$popup) this.videoClose();
				if (this.videoInline) {
					this.$video.removeClass("video--playing").addClass("video--ended");
					this.$video.removeClass("video--prepare");
	
					if (this.$video.hasClass("video__player--hero")) {
						$(".video--hero").slideUp(500);
						$(".hero").slideDown(500);
	
						$("html, body").animate(
							{
								scrollTop: 0,
							},
							500
						);
					}
	
					clearInterval(timer);
				}
			}
		},
	
		stopVideo: function () {
			if ($("body").data("videoView").$el[0] == this.$el[0]) {
				//console.log('stopVideo');
				//console.log(this.$el[0]);
	
				if (this.videoPlayer) {
					//console.log('this.videoPlayer -- STOP');
					this.videoPlayer.stopVideo();
					this.videoPlayer.clearVideo();
					//this.videoPlayer.destroy();
					this.$video.removeClass("video--playing video--prepare");
				}
				if (this.$popup) this.$popup.addClass("stop");
			}
		},
	
		initAutoplay: function () {
			var to;
			var t = this;
			var offTop = t.$video.offset().top;
			var height = t.$video.height();
	
			$(window).on("scroll", function () {
				clearTimeout(to);
				to = setTimeout(function () {
					if (t.$el.parents(".video--hero").length == 0) {
						if (window.youTubeAPIReady) {
							var sct = $(window).scrollTop();
							var wh = $(window).height();
							// console.log(sct, offTop, height)
							if (sct + wh > offTop + height / 2) {
								if (window.playedVideo !== true) {
									t.videoPlayerInit();
									window.playedVideo = true;
								}
							}
						} else {
							t.videoPlayerPrepare();
						}
					}
				}, 100);
			});
		},
	
		init: function () {
			if (!this.$el.data("videoView")) {
				this.$el.data("videoView", this);
				this.initView();
				this.initListeners();
				this.initPlugins();
	
				var t = this;
	
				if (!t.$video.length) {
					return;
				}
				setTimeout(function () {
					t.initAutoplay();
				}, 100);
	
				this.$closeBtn.on("click", function () {
					// t.$hero.slideDown(500);
					// t.$hero_video.slideUp(500);
	
					$(".hero").slideDown(500);
					$(".video--hero").slideUp(500);
	
					t.videoClose();
	
					// var id = $('iframe.video__embed').attr('id');
					// // $('iframe').remove();
					// // $('.video__player').prepend('<div class="video__embed" id="'+ id +'"></div>');
				});
	
				// close the video on escape key
				$(document).on("keydown", function (e) {
					if (e.key === "Escape") {
						t.videoClose();
					}
				});
			}
		},
	};
	
	function mobileSwiper($el) {
		this.$el = $el;
		this.$container = $("> *", this.$el);
		this.$wrapper = $("> *", this.$container);
		this.$slides = $("> *", this.$wrapper);
		this.$pagination = $(
			'<div class="swiper-pagination swiper-pagination--center"></div>'
		);
		this.swiper;
	}
	mobileSwiper.prototype = {
		constructor: mobileSwiper,
	
		initView: function () {
			var that = this;
		},
		initPlugins: function () {
			if (Modernizr.mq("(max-width: " + breakPoints.tablet + "px)")) {
				if (!this.swiper) {
					var $pagination = this.$pagination.clone();
	
					//if(this.$container.hasClass('swiper-container')) this.swiper.destroy(true, true);
	
					$pagination.appendTo(this.$container.parent());
	
					this.$container.addClass("swiper-container");
					this.$wrapper.addClass("swiper-wrapper");
					this.$slides.addClass("swiper-slide");
	
					this.swiper = new Swiper(this.$container, {
						a11y: swiperA11yOptions,
						keyboardControl: true,
						pagination: $pagination,
						paginationClickable: true,
						//autoHeight: true,
						speed: 500,
						bulletActiveClass: "active",
						parallax: true,
						bulletClass: "bullet",
	
						onSlideChangeEnd: function (swiper) {
							$(window).trigger("scroll");
						},
					});
				}
			} else {
				if (this.swiper) {
					this.swiper.destroy(true, true);
					this.swiper = false;
					$(".swiper-pagination", this.$el).remove();
				}
			}
		},
		initListeners: function () {
			var that = this;
			$(window).bind("resize orientationchange", function () {
				that.initPlugins();
			});
		},
		init: function () {
			this.initView();
			this.initListeners();
			//this.initPlugins();
		},
	};
	
	function teaserGridSwiper($el) {
		this.$el = $el;
		this.$container = $("> *", this.$el);
		this.$wrapper = $("> *", this.$container);
		this.$slides = $("> *", this.$wrapper);
		this.$image = $("span", this.$wrapper);
		this.$pagination = $('<div class="swiper-pagination"></div>');
		this.direction;
		//this.parallax		= {'horizontal': [-100, 0], 'vertical': [-100, 100]}
		this.touch = $("html.touch").length;
	
		this.autoplay;
		739;
	}
	teaserGridSwiper.prototype = {
		constructor: teaserGridSwiper,
	
		initView: function () {
			var that = this;
			that.initPlugins("horizontal");
		},
		initPlugins: function (direction) {
			var $pagination = this.$pagination.clone();
	
			if (this.direction == direction) return;
			this.direction = direction;
	
			if (
				this.$container.hasClass("swiper-container") &&
				typeof this.swiper !== "undefined"
			)
				this.swiper.destroy(true, true);
			$(".swiper-pagination", this.$el).remove();
	
			$pagination
				.addClass("pagination--" + direction)
				.appendTo(this.$container.parent());
			if (this.$slides.length < 2) {
				$pagination.hide();
			}
	
			if ($(window).width() < 740) {
				this.autoplay = false;
			} else {
				this.autoplay = 3000;
			}
	
			this.$container.addClass("swiper-container");
			this.$wrapper.addClass("swiper-wrapper");
			this.$slides.addClass("swiper-slide");
			//this.$image.attr('data-swiper-parallax', this.parallax[direction][0]);
			//this.$content.attr('data-swiper-parallax', this.parallax[direction][1]);
			if (this.$container.find(".swiper-slide").length > 1) {
				this.swiper = new Swiper(this.$container, {
					a11y: swiperA11yOptions,
					keyboardControl: true,
					pagination: $pagination,
					paginationClickable: true,
					direction: direction,
					centeredSlides: true,
					slidesPerView: 1,
					//autoHeight: true,
					speed: 500,
					bulletActiveClass: "active",
					parallax: true,
					bulletClass: "bullet",
					autoplay: this.autoplay,
					loop: true,
	
					onSlideChangeEnd: function (swiper) {
						$(window).trigger("scroll");
					},
				});
			}
		},
		initListeners: function () {
			var that = this;
			//$(window).bind('resize orientationchange',function(){});
		},
		init: function () {
			this.initView();
			this.initListeners();
			//this.initPlugins();
		},
	};
	
	function headlinesSwiper($el) {
		this.$el = $el;
		this.$container = $("> *", this.$el);
		this.$wrapper = $("> *", this.$container);
		this.$slides = $("> *", this.$wrapper);
		this.$image = $("span", this.$wrapper);
		this.$pagination = $('<div class="swiper-pagination"></div>');
		this.direction;
		//this.parallax		= {'horizontal': [-100, 0], 'vertical': [-100, 100]}
		this.touch = $("html.touch").length;
	}
	headlinesSwiper.prototype = {
		constructor: headlinesSwiper,
	
		initView: function () {
			var that = this;
			that.initPlugins("horizontal");
		},
		initPlugins: function (direction) {
			var $pagination = this.$pagination.clone();
	
			if (this.direction == direction) return;
			this.direction = direction;
	
			if (
				this.$container.hasClass("swiper-container") &&
				typeof this.swiper !== "undefined"
			)
				this.swiper.destroy(true, true);
			$(".swiper-pagination", this.$el).remove();
	
			$pagination
				.addClass("pagination--" + direction)
				.appendTo(this.$container.parent());
			if (this.$slides.length < 2) {
				$pagination.hide();
			}
	
			this.$container.addClass("swiper-container");
			this.$wrapper.addClass("swiper-wrapper");
			this.$slides.addClass("swiper-slide");
			//this.$image.attr('data-swiper-parallax', this.parallax[direction][0]);
			//this.$content.attr('data-swiper-parallax', this.parallax[direction][1]);
			if (this.$container.find(".swiper-slide").length > 1) {
				this.swiper = new Swiper(this.$container, {
					a11y: swiperA11yOptions,
					keyboardControl: true,
					pagination: $pagination,
					paginationClickable: true,
					direction: direction,
					centeredSlides: true,
					slidesPerView: 1,
					//autoHeight: true,
					speed: 500,
					bulletActiveClass: "active",
					parallax: true,
					bulletClass: "bullet",
					autoplay: 3000,
					loop: true,
	
					onSlideChangeEnd: function (swiper) {
						$(window).trigger("scroll");
					},
				});
			}
		},
		initListeners: function () {
			var that = this;
			//$(window).bind('resize orientationchange',function(){});
		},
		init: function () {
			this.initView();
			this.initListeners();
			//this.initPlugins();
		},
	};
	
	/* global Swiper */
	
	function Bricks($el) {
		this.$el = $el;
		this.$sw_container = $(".bricks__container", this.$el);
		this.$sw_wrapper = $(".bricks__container__wraper", this.$el);
		this.$sw_slides = $(".bricks__brick", this.$el);
		this.$sw_pagination = $(".bricks__pagination", this.$el);
		this.swiper;
	}
	
	Bricks.prototype = {
		init: function () {
			var self = this;
	
			this.$sw_container.addClass("swiper-container");
			this.$sw_wrapper.addClass("swiper-wrapper");
			this.$sw_slides.addClass("swiper-slide");
	
			var slidesPerView = [3, 2, 1];
			if (this.$sw_slides.length < 3) {
				slidesPerView = [this.$sw_slides.length, 1, 1];
			}
	
			this.swiper = new Swiper(this.$sw_container, {
				a11y: swiperA11yOptions,
				keyboardControl: true,
				pagination: self.$sw_pagination,
				paginationClickable: true,
				autoHeight: true,
				speed: 500,
				bulletActiveClass: "active",
				slidesPerView: slidesPerView[0],
				bulletClass: "bullet",
	
				breakpoints: {
					560: {
						slidesPerView: slidesPerView[2],
						spaceBetweenSlides: 0,
					},
					900: {
						slidesPerView: slidesPerView[1],
						spaceBetweenSlides: 0,
					},
					1200: {
						slidesPerView: slidesPerView[0],
						spaceBetweenSlides: 0,
					},
				},
				onSlideChangeStart: function (swiper) {
					// that.itemsHide();
				},
				onSlideChangeEnd: function (swiper) {
					$(window).trigger("scroll");
				},
				onInit: function (swiper) {
					// that.updateView();
				},
			});
		},
	};
	
	function bubbleGrid($el) {
		this.$el = $el;
		this.$wrapper = $(".bubble-grid__wrapper", this.$el);
		this.$items = $(".bubble-grid__items", this.$el);
		this.$item = $("> div, > a", this.$items);
		this.$item_inner = $("> div", this.$item);
		this.$line = $('<i class="bubble-grid__line" aria-hidden="true"></i>');
		this.$between = $('<i class="bubble-grid__between"></i>');
		this.$line_start = $('<span class="bubble-grid__line-start"></span>');
		this.$line_stop = $('<span class="bubble-grid__line-stop"></span>');
		this.$line_to_start = this.$line.clone();
		this.$line_to_stop = this.$line.clone();
	
		this.$sw_container = $(".bubble-grid__swiper", this.$el);
		this.$sw_wrapper = $("> *", this.$sw_container);
		this.$sw_slides = $("> *", this.$sw_wrapper);
		this.$sw_pagination = $(
			'<div class="swiper-pagination swiper-pagination--center"></div>'
		);
		this.swiper;
		this.xpos;
		this.timerUpdate;
		this.timerUpdateInt;
	}
	bubbleGrid.prototype = {
		constructor: bubbleGrid,
	
		initView: function () {
			var that = this;
			// console.log(this.$el);
			this.$el.addClass("bubble-grid--cols-" + this.$item.length);
			//this.$wrapper.prepend(this.$line_start).prepend(this.$line_stop).prepend(this.$line_to_start).prepend(this.$line_to_stop);
	
			this.$item.each(function (i) {
				var $self = $(this),
					$next = $self.next();
	
				$self.addClass("item--i-" + i);
				if ($next.length) {
					var $line_1 = that.$line.clone();
					var $line_2 = that.$line.clone();
					var $between = that.$between.clone();
					$self
						.data("next", $next)
						.data("between", $between)
						.data("line_1", $line_1)
						.data("line_2", $line_2);
					$("> div, > a", $self).prepend($between);
					that.$items.prepend($line_1).prepend($line_2);
					if (i == 0) {
						$self.addClass("item--first");
					}
				} else {
					$self.addClass("item--last");
				}
			});
	
			that.updateView();
	
			$("> div > div, > a > div", this.$item).dotdotdot({
				watch: true,
			});
	
			// this.showFirstItem();
		},
		updateView: function () {
			var that = this;
	
			this.$item.each(function (i) {
				var $self = $(this);
				if ($self.next().length) {
					//that.drawLine($('.bubble-grid__items > div:eq('+i+') span'), $('.bubble-grid__items > div:eq('+(i+1)+') span'), $line);
					that.drawLine(
						$("span", $self),
						$self.data("between"),
						$self.data("line_1")
					);
					that.drawLine(
						$self.data("between"),
						$("span", $self.data("next")),
						$self.data("line_2")
					);
					if (i == 0) {
						//that.drawLine($('span', $self), $('span', $self.data('next')), $self.data('line_1'));
					}
				} else {
					//that.drawLine($('span', $self), that.$line_stop, that.$line_to_stop);
				}
			});
		},
		initPlugins: function () {
			var that = this;
	
			if (!this.swiper) {
				var $pagination = this.$sw_pagination.clone();
	
				this.$sw_container.addClass("swiper-container");
				this.$sw_wrapper.addClass("swiper-wrapper");
				this.$sw_slides.addClass("swiper-slide");
	
				$pagination.appendTo(this.$sw_container.parent());
	
				var slides_per_view = 4;
				var slides_per_group = 4;
				var breakpoints = {
					480: {
						slidesPerView: 1,
						slidesPerGroup: 1,
						spaceBetweenSlides: 0,
					},
					740: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetweenSlides: 0,
					},
					1200: {
						slidesPerView: 3,
						slidesPerGroup: 3,
						spaceBetweenSlides: 0,
					},
					1920: {
						slidesPerView: 4,
						slidesPerGroup: 4,
						spaceBetweenSlides: 0,
					},
				};
				if (that.$wrapper.hasClass("bubble-grid__wrapper--about")) {
					slides_per_view = 4;
					breakpoints = {
						480: {
							slidesPerView: 1,
							slidesPerGroup: 1,
							spaceBetweenSlides: 0,
						},
						740: {
							slidesPerView: 2,
							slidesPerGroup: 2,
							spaceBetweenSlides: 0,
						},
						1550: {
							slidesPerView: 3,
							slidesPerGroup: 3,
							spaceBetweenSlides: 0,
						},
					};
				}
	
				this.swiper = new Swiper(this.$sw_container, {
					a11y: swiperA11yOptions,
					keyboardControl: true,
					pagination: $pagination,
					paginationClickable: true,
					autoHeight: true,
					speed: 500,
					bulletActiveClass: "active",
					slidesPerView: slides_per_view,
					slidesPerGroup: slides_per_group,
					bulletClass: "bullet",
					nextButton: ".bubble-grid__next",
					prevButton: ".bubble-grid__prev",
	
					breakpoints: breakpoints,
					onSlideChangeStart: function (swiper) {
						that.itemsHide();
					},
					onSlideChangeEnd: function (swiper) {
						$(window).trigger("scroll");
					},
					onInit: function (swiper) {
						that.updateView();
					},
				});
	
				this.$el.find(".bubble-grid__prev").on("click", function () {
					that.swiper.slidePrev();
				});
				this.$el.find(".bubble-grid__next").on("click", function () {
					that.swiper.slideNext();
				});
			}
		},
		itemShow: function ($target) {
			this.itemsHide();
			if (!this.$wrapper.hasClass("bubble-grid__wrapper--about")) {
				$target.css("height", "130px");
			}
			$target.parent().parent().addClass("bubble-grid__item--show");
			$target.trigger("destroy");
	
			//setTimeout(function(){
			//$target.css('height', 'auto');
			$target.css("height", $target.prop("scrollHeight") + "px");
			//},100);
		},
		itemHide: function ($target) {
			if (!this.$wrapper.hasClass("bubble-grid__wrapper--about")) {
				$target.css("height", "130px");
			}
			$target.parent().parent().removeClass("bubble-grid__item--show");
			$target.dotdotdot({
				watch: true,
			});
		},
		itemsHide: function () {
			this.itemHide($(".bubble-grid__item--show > div > div"));
		},
		initListeners: function () {
			var that = this;
			if ($("html.no-touch").length) {
				this.$item_inner.bind("mouseenter", function (e) {
					that.itemShow($("> div", $(e.currentTarget)));
				});
				this.$item.bind("focus", function (e) {
					that.itemShow($("> div > div", $(e.currentTarget)));
	
					// if we have the slider, slide to the item
					if (that.swiper) {
						var index = $(e.currentTarget).data("index");
						that.swiper.slideTo(index);
					}
				});
				this.$item_inner.bind("mouseleave", function (e) {
					that.itemHide($("> div", $(e.currentTarget)));
				});
				this.$item.bind("blur", function (e) {
					that.itemHide($("> div > div", $(e.currentTarget)));
				});
			} else {
				this.$item_inner.bind("click", function (e) {
					$target = $("> div", $(e.currentTarget));
					if ($target.parent().parent().hasClass("bubble-grid__item--show")) {
						that.itemsHide();
					} else {
						that.itemShow($target);
					}
				});
			}
			$(window).bind("resize orientationchange", function () {
				that.updateView();
			});
		},
		lineDistance: function (x, y, x0, y0) {
			return Math.sqrt((x -= x0) * x + (y -= y0) * y);
		},
		drawLine: function (a, b, line) {
			var $a = a,
				$b = b,
				$l = line;
			var x1_offset = $a.width() / 2;
			var y1_offset = $a.height() / 2;
			var x2_offset = $b.width() / 2;
			var y2_offset = $b.height() / 2;
			var x1 = $a.offset().left + x1_offset;
			var x2 = $b.offset().left + x2_offset;
			var y1 = $a.offset().top + y1_offset;
			var y2 = $b.offset().top + y2_offset;
	
			var hypotenuse = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
			var angle = Math.atan2(y1 - y2, x1 - x2) * (180 / Math.PI);
			if (angle >= 90 && angle < 180) {
				y1 = y1 - (y1 - y2);
			}
			if (angle > 0 && angle < 90) {
				x1 = x1 - (x1 - x2);
				y1 = y1 - (y1 - y2);
			}
			if (angle <= 0 && angle > -90) {
				x1 = x1 - (x1 - x2);
			}
			$l.queue(function () {
				$(this).offset({ top: y1, left: x1 });
				$(this).dequeue();
			})
				.queue(function () {
					$(this).width(hypotenuse);
					$(this).dequeue();
				})
				.queue(function () {
					//$(this).rotate(angle);
					$(this).css("transform", "rotate(" + angle + "deg)");
					$(this).dequeue();
				});
		},
		/*drawLine: function(a, b, line) {
			var $a = a, $b = b, $l = line;
			var pointA = $a.offset();
			var pointB = $b.offset();
			var pointAcenterX = $a.width() / 2;
			var pointAcenterY = $a.height() / 2;
			var pointBcenterX = $b.width() / 2;
			var pointBcenterY = $b.height() / 2;
			var angle = Math.atan2(pointB.top - pointA.top, pointB.left - pointA.left) * 180 / Math.PI;
			var distance = this.lineDistance(pointA.left, pointA.top, pointB.left, pointB.top);
	
			// Set Angle
			$l.css('transform', 'rotate(' + angle + 'deg)');
	
			// Set Width
			$l.css('width', distance + 'px');
	
			// Set Position
			$l.css('position', 'absolute');
			if(pointB.left < pointA.left) {
				$l.offset({top: pointA.top + pointAcenterY, left: pointB.left + pointBcenterX});
			} else {
				$l.offset({top: pointA.top + pointAcenterY, left: pointA.left + pointAcenterX});
			}
		},*/
	
		showFirstItem: function () {
			var $firstItem = this.$item_inner.eq(0).find("> div");
			this.itemShow($firstItem);
		},
		init: function () {
			this.initView();
			this.initListeners();
			this.initPlugins();
		},
	};
	
	//var b = new bubbleGrid('.bubble-grid').init();
	
	/*
	function lineDistance(x, y, x0, y0){
			return Math.sqrt((x -= x0) * x + (y -= y0) * y);
	};
	function drawLine(a, b, line) {
		var $a = a, $b = b, $l = line;
		var pointA = $a.offset();
		var pointB = $b.offset();
		var pointAcenterX = $a.width() / 2;
		var pointAcenterY = $a.height() / 2;
		var pointBcenterX = $b.width() / 2;
		var pointBcenterY = $b.height() / 2;
		var angle = Math.atan2(pointB.top - pointA.top, pointB.left - pointA.left) * 180 / Math.PI;
		var distance = lineDistance(pointA.left, pointA.top, pointB.left, pointB.top);
	
		// Set Angle
		$l.css('transform', 'rotate(' + angle + 'deg)');
	
		// Set Width
		$l.css('width', distance + 'px');
	
		// Set Position
		$l.css('position', 'absolute');
		if(pointB.left < pointA.left) {
			$l.offset({top: pointA.top + pointAcenterY, left: pointB.left + pointBcenterX});
		} else {
			$l.offset({top: pointA.top + pointAcenterY, left: pointA.left + pointAcenterX});
		}
	}
	
	$line = $('<span class="bubble-grid__line"></span>');
	$('.bubble-grid__items').prepend($line);
	
	setInterval(function() {
		//drawLine('.a', '.b', '.line');
		drawLine($('.bubble-grid__items > div:eq(0) span'), $('.bubble-grid__items > div:eq(1) span'), $line);
	});
	
	function drawLine(a, b, line) {
		var pointA = $(a).offset();
		var pointB = $(b).offset();
		var pointAcenterX = $(a).width() / 2;
		var pointAcenterY = $(a).height() / 2;
		var pointBcenterX = $(b).width() / 2;
		var pointBcenterY = $(b).height() / 2;
		var angle = Math.atan2(pointB.top - pointA.top, pointB.left - pointA.left) * 180 / Math.PI;
		var distance = lineDistance(pointA.left, pointA.top, pointB.left, pointB.top);
	
		// INFO
		$('.info .point-a').text('Point-A: Left: ' + pointA.left + ' Top: ' + pointA.top);
		$('.info .point-b').text('Point-B: Left: ' + pointB.left + ' Top: ' + pointB.top);
		$('.info .angle').text('Angle: ' + angle);
		$('.info .distance').text('Distance: ' + distance);
	
		// Set Angle
		$(line).css('transform', 'rotate(' + angle + 'deg)');
	
		// Set Width
		$(line).css('width', distance + 'px');
	
		// Set Position
		$(line).css('position', 'absolute');
		if(pointB.left < pointA.left) {
			$(line).offset({top: pointA.top + pointAcenterY, left: pointB.left + pointBcenterX});
		} else {
			$(line).offset({top: pointA.top + pointAcenterY, left: pointA.left + pointAcenterX});
		}
	}
	*/
	
	function faq($el) {
		this.$el 				= $el;
	
		// elements
		this.$answersContainer = $el.find(this.classes.answersContainer);
		this.$input = $el.find(this.classes.input);
	
		this.answers = $(".js-faq-answer");
	
		// vars
		this.ajaxCall = undefined;
		this.ajaxUrl = $el.data('ajaxUrl');
		this.resultsLoading = false;
	
		this.init();
	};
	faq.prototype = {
		constructor: faq,
	
		classes: {
			answersContainer: '.js-faq-answers-container',
			answers: '.js-faq-answers',
			input: '.js-faq-input',
		},
	
	
		initListeners: function(){
			this.$input.on('keyup', {self: this}, this.inputKeyupHandler);
		},
	
		init: function(){
			this.initListeners();
		},
	
		loadFaqResults: function(search){
			
			// Loop through all list items, and hide those who don't match the search query
			for (i = 0; i < this.answers.length; i++) {
				a = this.answers[i];
			
				txtValue = a.textContent || a.innerText;
	
				if (txtValue.toLowerCase().indexOf(search) > -1) {
					this.answers[i].style.display = "";
				} else {
					this.answers[i].style.display = "none";
				}
			}
		},
	
		inputKeyupHandler: function(event){
			var self = event.data.self;
			var search = $(this).val();
			self.loadFaqResults(search);
		},
	
	}
	
	function accordion($el) {
		this.$el = $el;
		this.active_filter = this.$el.attr("data-active-filter")
			? this.$el.attr("data-active-filter")
			: false;
	
		this.accordionOpen = false;
	
		this.states = {
			isActive: "is-active",
		};
	
		this.elements = {
			header: $el.find(".js-accordion__header"),
			body: $el.find(".js-accordion__body"),
			bodyInner: $el.find(".js-accordion__body-inner"),
	
			heading: $el.find(".js-filter__heading"),
			category: $el.find(".js-filter__category"),
		};
	
		this.init();
	}
	
	accordion.prototype = {
		constructor: accordion,
	
		init: function () {
			this.initListeners();
			this.checkActiveFilter();
		},
	
		initListeners: function () {
			this.elements.header.on("click", this.headerClickHandler.bind(this));
			this.elements.category.on("click", this.changeHeading.bind(this));
		},
	
		checkActiveFilter: function () {
			if (this.active_filter) {
				this.setActiveFilter(this.active_filter);
			}
		},
	
		headerClickHandler: function (e) {
			e.preventDefault();
			this.toggleAccordion(e);
		},
	
		toggleAccordion: function () {
			this.accordionOpen ? this.closeAccordion() : this.showAccordion();
		},
	
		setActiveFilter: function (filter) {
			this.elements.heading.removeClass(this.states.isActive);
	
			this.$el
				.find('.js-filter__heading[data-filter="' + filter + '"]')
				.addClass(this.states.isActive);
	
			// set new list of categories
			this.elements.category.addClass(this.states.isActive);
	
			this.$el
				.find('.js-filter__category[data-filter="' + filter + '"]')
				.removeClass(this.states.isActive);
		},
	
		changeHeading: function (e) {
			var newCategory = e.currentTarget.dataset.filter;
	
			// set heading an active state
			this.elements.heading.removeClass(this.states.isActive);
	
			this.$el
				.find('.js-filter__heading[data-filter="' + newCategory + '"]')
				.addClass(this.states.isActive);
			this.elements.header.click();
	
			// set new list of categories
			this.elements.category.addClass(this.states.isActive);
	
			this.$el
				.find('.js-filter__category[data-filter="' + newCategory + '"]')
				.removeClass(this.states.isActive);
		},
	
		showAccordion: function () {
			this.accordionOpen = true;
			this.elements.header.attr("aria-expanded", "true");
			this.elements.body.attr("aria-hidden", "false");
			const contentHeight = this.elements.bodyInner.outerHeight();
			this.elements.body.css({ maxHeight: contentHeight + "px" });
		},
	
		closeAccordion: function () {
			this.accordionOpen = false;
			this.elements.header.attr("aria-expanded", "false");
			this.elements.body.attr("aria-hidden", "true");
			this.elements.body.css({ maxHeight: 0 });
		},
	};
	
	function filter($el) {
	  this.$el = $el;
	  this.active_filter = this.$el.attr('data-active-filter') ? this.$el.attr('data-active-filter') : false;
	
	  this.states = {
			isHidden: "is-hidden",
			isActive: "is-active",
	  };
	
	  this.elements = {
			container: $el.find(".js-filter__container"),
			items: $el.find(".js-filter__item"),
			category: $el.find(".js-filter__category"),
	
			heading: $el.find(".js-filter__heading"),
			accordion: $el.find(".js-accordion__header"),
	  };
	
	  this.init();
	}
	
	
	filter.prototype = {
	  constructor: filter,
	
	
	  init: function () {
	    this.initListeners();
	    this.checkActiveFilter();
	  },
	
	
		initListeners: function () {
	    this.elements.category.on("click", this.categoryClickHandler.bind(this));
		},
	
	  checkActiveFilter: function () {
	    if(this.active_filter){
	      this.setActiveFilter(this.active_filter);
	    }
	  },
	
	  setActiveFilter: function (filter) {
	    this.elements.items.hide().filter('[data-filter="'+ filter +'"]').show();
	  },
	
		categoryClickHandler: function(e) {
			this.filterItems(e);
		},
	
		filterItems: function (e) {
	    var newCategory = e.currentTarget.dataset.filter;
	
	    if(newCategory === 'all') {
	      this.elements.items.show();
	    } else {
	      this.elements.items.hide().filter('[data-filter="'+ newCategory +'"]').show();
	    }
	
	    if($(e.target).parents('.js-job-list').length > 0){
	      var $wrap = $(e.target).parents('.js-job-list').first();
	      var visible_count = 0;
	      $wrap.find('.js-filter__item').each(function(){
	        if($(this).is(':visible')) visible_count++;
	      });
	      if(visible_count > 0){
	        $wrap.find('.js-jobs-here').show(0);
	        $wrap.find('.js-no-jobs-here').hide(0);
	      } else {
	        $wrap.find('.js-no-jobs-here').show(0);
	        $wrap.find('.js-jobs-here').hide(0);
	      }
	    }
		}
	
	
	
	};
	
	function kernOverlay($el) {
		this.$el = $el;
		this.$item = $(".js-kern__item", this.$el);
		this.$paginationItem = $(".js-kern__pagination-item", this.$el);
		this.$close = $(".js-kern__overlay-close", this.$el);
	
		this.$overlayItem = $(".js-kern__overlay-item", this.$el);
	
		this.lockElement = document.querySelector(".site-wrapper");
		this.documentElement = document.documentElement;
	
		this.locked = false;
		this.scrollPos = {
			x: 0,
			y: 0,
		};
	
		this.states = {
			isLocked: "is-locked",
		};
	
		// swiper data
		this.$swiperElements = $(".js-kern__swiper", this.$el);
		this.$thumbItems = $(".image-gallery__thumbnails__item", this.$el);
		this.mainSwipers = [];
		this.thumbSwipers = [];
		this.parent;
	}
	kernOverlay.prototype = {
		constructor: kernOverlay,
	
		init: function () {
			var t = this;
	
			t.initListeners();
			t.initSwipers();
		},
	
		initListeners: function () {
			this.$item.on("click", this.showOverlay.bind(this));
	
			this.$paginationItem.on("click", this.showOverlayItem.bind(this));
	
			this.$close.on("click", this.hideOverlay.bind(this));
			this.$close.on("click", this.hideOverlayItem);
	
			this.$thumbItems.on("click", this.slideToClickedThumb.bind(this));
		},
	
		showOverlay: function (e) {
			var t = this;
			t.$overlay = $(".js-kern__overlay", this.$el);
			//$('body').append(this.$overlay);
			t.$overlay.addClass("is-visible");
			setTimeout(function () {
				t.$overlay.addClass("is-active");
			}, 10);
	
			t.lockPage();
			t.showOverlayItem(e);
		},
	
		hideOverlay: function () {
			var t = this;
	
			t.$overlay = $(".js-kern__overlay", t.$el);
			t.$overlay.removeClass("is-active");
			setTimeout(function () {
				t.$overlay.removeClass("is-visible");
			}, 300);
	
			// remove if there is active item
			$(".js-kern__overlay-item.is-active", t.$el).removeClass("is-active");
			$(".js-kern__pagination-item.is-active", t.$el).removeClass("is-active");
	
			t.unlockPage();
		},
	
		showOverlayItem: function (e) {
			var t = this;
	
			var itemIndex = e.currentTarget.dataset.item;
	
			// remove if there is active item
			$(".js-kern__overlay-item.is-active", t.$el).removeClass("is-active");
			$(".js-kern__pagination-item.is-active", t.$el).removeClass("is-active");
	
			$(".js-kern__overlay-item[data-item='" + itemIndex + "']", t.$el).addClass(
				"is-active"
			);
			$(
				".js-kern__pagination-item[data-item='" + itemIndex + "']",
				t.$el
			).addClass("is-active");
	
			t.mainSwipers[itemIndex].update();
			t.thumbSwipers[itemIndex].update();
			$(window).trigger("scroll");
		},
	
		slideToClickedThumb: function (e) {
			const thumbIndex = e.currentTarget.dataset.index;
			const parentIndex = e.currentTarget.closest(".js-kern__overlay-item")
				.dataset.item;
			if (this.mainSwipers[parentIndex]) {
				this.mainSwipers[parentIndex].slideTo(thumbIndex);
			}
		},
	
		initSwipers: function () {
			var t = this;
			this.$swiperElements.each(function (index) {
				const $this = $(this);
				const thumbSlider = t.initThumbSwiper(
					index,
					$this.find(".js-kern__swiper-thumbs")
				);
				const mainSlider = t.initMainSwiper(
					index,
					$this.find(".js-kern__swiper-main"),
					$this
				);
	
				t.thumbSwipers.push(thumbSlider);
				t.mainSwipers.push(mainSlider);
			});
		},
	
		initMainSwiper: function (index, $swiperElement, $parent) {
			const that = this;
	
			return new Swiper($swiperElement, {
				a11y: swiperA11yOptions,
				keyboardControl: true,
				slidesPerView: 1,
				spaceBetween: 10,
				pagination: false,
				speed: 500,
				loop: false,
				nextButton: $parent.find(".js-kern__swiper-bottom__next"),
				prevButton: $parent.find(".js-kern__swiper-bottom__prev"),
				onSlideChangeStart: function (swiper) {
					$(window).trigger("scroll");
					const thumbSwiper = that.thumbSwipers[index];
					if (thumbSwiper) {
						const $thumbSwiperEl = $(thumbSwiper.container);
						$thumbSwiperEl
							.find(".image-gallery__thumbnails__item")
							.removeClass("is-active");
						$thumbSwiperEl
							.find(".image-gallery__thumbnails__item")
							.eq(swiper.realIndex)
							.addClass("is-active");
						thumbSwiper.slideTo(swiper.realIndex);
					}
				},
				onSlideChangeEnd: function (swiper) {
					$(window).trigger("scroll");
				},
			});
		},
	
		initThumbSwiper: function (index, $swiperElement) {
			return new Swiper($swiperElement, {
				a11y: swiperA11yOptions,
				keyboardControl: true,
				spaceBetween: 12,
				slidesPerView: 4,
				lazyLoading: true,
	
				breakpoints: {
					380: {
						slidesPerView: 3,
					},
				},
				onSlideChangeEnd: function (swiper) {
					$(window).trigger("scroll");
				},
			});
		},
	
		lockPage: function () {
			if (this.locked || !this.lockElement) {
				return false;
			}
			this.scrollPos = {
				x: window.scrollX,
				y: window.scrollY,
			};
			this.locked = true;
			this.lockElement.style.top = -this.scrollPos.y + "px";
			this.documentElement.classList.add(this.states.isLocked);
		},
	
		unlockPage: function () {
			if (!this.locked) {
				return false;
			}
			this.documentElement.classList.remove(this.states.isLocked);
			window.scrollTo(this.scrollPos.x, this.scrollPos.y);
			this.lockElement.style.top = "auto";
			this.locked = false;
		},
	};
	
	function imageArchive($el) {
		this.$el = $el;
		this.$item = $(".js-image-archive__item", this.$el);
		this.$paginationItem = $(".js-image-archive__pagination-item", this.$el);
		this.$close = $(".js-image-archive__overlay-close", this.$el);
	
		this.$overlayItem = $(".js-image-archive__overlay-item", this.$el);
	
		this.lockElement = document.querySelector(".site-wrapper");
		this.documentElement = document.documentElement;
	
		this.locked = false;
		this.scrollPos = {
			x: 0,
			y: 0,
		};
	
		this.states = {
			isLocked: "is-locked",
		};
	}
	imageArchive.prototype = {
		constructor: imageArchive,
	
		init: function () {
			var t = this;
	
			t.initListeners();
		},
	
		initListeners: function () {
			this.$item.on("click", this.showOverlay.bind(this));
			this.$close.on("click", this.hideOverlay.bind(this));
		},
	
		showOverlay: function (e) {
			var t = this;
	
			if(!e.target.classList.contains('image-archive__download')) {
				t.$overlay = $(".js-image-archive__overlay", t.$el);
	
				t.$overlay.addClass("is-active");
	
				t.lockPage(); 
			}
	
		},
	
		hideOverlay: function () {
			var t = this;
	
			t.$overlay = $(".js-image-archive__overlay", t.$el);
	
			t.$overlay.removeClass("is-active");
	
	
			// remove if there is active item
			$(".js-image-archive__overlay-item.is-active").removeClass("is-active");
			$(".js-image-archive__pagination-item.is-active").removeClass("is-active");
	
			t.unlockPage();
		},
	
	
		lockPage: function () {
			console.log("lockpage");
			if (this.locked || !this.lockElement) {
				return false;
			}
			this.scrollPos = {
				x: window.scrollX,
				y: window.scrollY,
			};
			this.locked = true;
			this.lockElement.style.top = -this.scrollPos.y + "px";
			this.documentElement.classList.add(this.states.isLocked);
		},
	
		unlockPage: function () {
			if (!this.locked) {
				return false;
			}
			this.documentElement.classList.remove(this.states.isLocked);
			window.scrollTo(this.scrollPos.x, this.scrollPos.y);
			this.lockElement.style.top = "auto";
			this.locked = false;
		},
	};
	
	function imageArchiveSwiper($el) {
		this.$el = $el;
		this.$top = $(".js-image-archive__swiper-top", this.$el);
		this.$container = $("> *", this.$top);
		this.$wrapper = $(".js-image-archive__swiper-top__wrapper", this.$container);
		this.$slides = $("> *", this.$wrapper);
		this.$image = $("span", this.$wrapper);
		this.$pagination = $('<div class="swiper-pagination"></div>');
		this.direction;
		//this.parallax		= {'horizontal': [-100, 0], 'vertical': [-100, 100]}
		this.touch = $("html.touch").length;
	
		this.$next = $(".js-image-archive__swiper-top__next", this.$top);
		this.$prev = $(".js-image-archive__swiper-top__prev", this.$top);
	
		this.$thumbs = $(".js-image-archive__swiper-bottom", this.$el);
		this.$containerThumbs = $("> *", this.$thumbs);
		this.$wrapperThumbs = $(
			".js-image-archive__swiper-bottom__wrapper",
			this.$containerThumbs
		);
		this.$slidesThumbs = $("> *", this.$wrapperThumbs);
		this.$imageThumbs = $("span", this.$wrapperThumbs);
		this.$paginationThumbs = $('<div class="swiper-pagination"></div>');
	
		this.$nextThumbs = $(".js-image-archive__swiper-bottom__next", this.$thumbs);
		this.$prevThumbs = $(".js-image-archive__swiper-bottom__prev", this.$thumbs);
	}
	imageArchiveSwiper.prototype = {
		constructor: imageArchiveSwiper,
	
		initView: function () {
			var that = this;
			that.initThumbs("horizontal");
			that.initPlugins("horizontal");
		},
	
		initPlugins: function (direction) {
			var that = this;
	
			if (this.direction == direction) return;
			this.direction = direction;
	
			if (
				this.$container.hasClass("swiper-container") &&
				typeof this.swiper !== "undefined"
			)
				this.swiper.destroy(true, true);
			$(".swiper-pagination", this.$top).remove();
	
			this.$container.addClass("swiper-container");
			this.$wrapper.addClass("swiper-wrapper");
			this.$slides.addClass("swiper-slide");
			//this.$image.attr('data-swiper-parallax', this.parallax[direction][0]);
			//this.$content.attr('data-swiper-parallax', this.parallax[direction][1]);
			if (this.$container.find(".swiper-slide").length > 1) {
				this.swiper = new Swiper(this.$container, {
					a11y: swiperA11yOptions,
					keyboardControl: true,
	
					nextButton: this.$nextThumbs,
					prevButton: this.$prevThumbs,
	
					pagination: false,
					direction: direction,
					//autoHeight: true,
					speed: 500,
	
					// autoplay: 3000,
					loop: false,
	
					onSlideChangeStart: function (swiper) {
						$(window).trigger("scroll");
						that.$containerThumbs
							.find(".image-gallery__thumbnails__item")
							.removeClass("is-active");
						that.$containerThumbs
							.find(".image-gallery__thumbnails__item")
							.eq(that.swiper.realIndex)
							.addClass("is-active");
					},
				});
			}
		},
	
		initThumbs: function (direction) {
			var that = this;
	
			if (
				this.$containerThumbs.hasClass("swiper-container") &&
				typeof this.swiperThumbs !== "undefined"
			)
				this.swiperThumbs.destroy(true, true);
			$(".swiper-pagination", this.$thumbs).remove();
	
			this.$containerThumbs.addClass("swiper-container");
			this.$wrapperThumbs.addClass("swiper-wrapper");
			this.$slidesThumbs.addClass("swiper-slide");
			//this.$image.attr('data-swiper-parallax', this.parallax[direction][0]);
			//this.$content.attr('data-swiper-parallax', this.parallax[direction][1]);
			if (this.$containerThumbs.find(".swiper-slide").length > 1) {
				this.swiperThumbs = new Swiper(this.$containerThumbs, {
					a11y: swiperA11yOptions,
					keyboardControl: true,
					spaceBetween: 16,
					slidesPerView: 4,
	
					breakpoints: {
						360: {
							slidesPerView: 2,
						},
						480: {
							slidesPerView: 3,
						},
					},
				});
			}
	
			$(".image-gallery__thumbnails__item").on("click", function () {
				$(this).siblings().removeClass("is-active");
				$(this).addClass("is-active");
				that.swiper.slideTo($(this).index());
			});
	
			// that.$nextThumbs.removeClass('swiper-button-disabled');
		},
		initListeners: function () {
			var that = this;
			//$(window).bind('resize orientationchange',function(){});
		},
		init: function () {
			this.initView();
			this.initListeners();
			//this.initPlugins();
		},
	};
	
	function preloader() {}
	
	preloader.prototype = {
	  showPreloader: function($element, position){
	    var self = this;
	    var $preloader = $('<div class="preloader"><div class="preloader__inner"></div></div>');
	    if( !$element.find('.preloader').length ){
		    if(position == 'prepend'){
			    $element.prepend($preloader);
		    } else {
			    $element.append($preloader);
		    }
	    }
	  },
	
	  hidePreloader: function($element){
	    var $preloader = $element.find('.preloader');
	    if($preloader.length){
	      $preloader.remove();
	    }
	  }
	};
	
	function smoothScroll() {
		this.init();
	};
	
	smoothScroll.prototype = {
		constructor: smoothScroll,
	
		classes: {
			link: '.js-smooth-scroll',
		},
	
		init: function(){
			this.initListeners();
			this.scrollToHash();
		},
	
		initListeners: function(){
			if($('.js-presslist-link').length > 0 && $('[data-type=presslist]').length < 1){
				$('.js-presslist-link').remove();
			}
			
			$(document).on('click', this.classes.link, {self: this}, this.linkClickHandler);
		},
	
		linkClickHandler: function(event){
			event.preventDefault();
		  var self = event.data.self;
		  var anchor = $(this).attr('href');
			self.scrollToElement(anchor);
		},
	
		scrollToElement: function(selector){
		  var self = this;
		  var top = $(selector).offset().top - 100;
		  TweenLite.to(window, 0.7, {scrollTo: top, ease: Power2.easeInOut});
		},
	
		scrollToHash: function(selector){		
			var hash = window.location.hash;
			if ($(hash).length > 0) {	
				setTimeout(function(){
					var top = $(hash).offset().top - 100;
					$(hash).attr('data-top', top);
					TweenLite.to(window, 0.7, {scrollTo: top, ease: Power2.easeInOut});	
				}, 100);
			}
		},
	
	}
	
	
	
	
	function sidebarMenu($el) {
		this.$el = $el;
	
		this.$link = $el.find('a');
	
		this.init();
	};
	
	sidebarMenu.prototype = {
		constructor: sidebarMenu,
	
		init: function() {
			this.generateSidebarMenu();
			this.initListeners();
		},
	
		initListeners: function() {
			this.$link.on('click', {
				self: this
			}, this.linkClickHandler);
		},
	
		linkClickHandler: function(event) {
			var self = event.data.self;
			event.preventDefault();
			var href = $(this).attr('href');
			self.markSidebarLinkByHref(href);
		},
	
		markSidebarLinkByHref: function(href) {
			var self = this;
			self.$link.filter('.is-active').removeClass('is-active');
			self.$link.filter('[href="' + href + '"]').addClass('is-active');
		},
	
		generateSidebarMenu: function() {
			var $titles = $('.js-sidebarNavElement');
			var $list = this.$el.find('ul');
			var offsets = [];
			$list.empty();
	
			$titles.each(function(i) {
				var $t = $(this);
				var addClass = '';
				// if (i === 0) {
				// 	addClass = ' class="is-active"';
				// }
				var $navEl = $('<li' + addClass + '>' + $t.text() + '</li>');
				$navEl.on('click', function() {
					// var top = $t.offset().top;
					// $(this).addClass('is-active').siblings().removeClass('is-active');
					TweenLite.to(window, 0.7, {
						scrollTo: $t.offset().top + $t.outerHeight() - $t.height() - 100,
						ease: Power2.easeInOut
					});
				}).on('check', function() {
					offsets.push([$t.offset().top + $t.outerHeight(), this]);
				});
				$list.append($navEl);
			});
	
			var to;
			$(document).off('stickyNavbarScroll').on('stickyNavbarScroll', function() {
				clearTimeout(to);
				to = setTimeout(function() {
					var winScroll = $(window).scrollTop();
					offsets.length = 0;
					$('.sidebar-menu__content li').each(function() {
						$(this).trigger('check');
					});
					// console.log(offsets);
					for (var i = 0; i < offsets.length; i++) {
						if (offsets[i][0] - winScroll > 0) {
							$(offsets[i][1]).addClass('is-active').siblings().removeClass('is-active');
							return false;
						}
					}
				}, 5);
			});
			$(document).trigger('stickyNavbarScroll');
		}
	
	};
	
	var PageNav = function ($el) {
		this.$el = $el;
		this.$links = $(".nav-page__item__link", $el);
		this.$container = $(".nav-page__container", $el);
		this.relations = {};
		this.scrollPos = 0;
		this.actNav;
	
		this.mobile = {
			$open: $(".nav-page__mobile__open", $el),
			$close: $(".nav-page__mobile__close", $el),
			$name: $(".nav-page__mobile__current", $el),
			isOpen: false,
		};
	
		if (this.$links.length) {
			this.init();
		}
	};
	
	PageNav.prototype = {
		init: function () {
			var t = this;
	
			t.setAnchors();
			t.setRelationsPos();
			t.setClasses();
	
			t.scrollEventListener();
			t.fixEventListener();
			t.scrollToSectionEventListner();
			t.mobileTriggerEventListener();
		},
	
		setVariables: function () {
			this.scrollPos = $(window).scrollTop();
			this.screenHeight = $(window).height();
		},
	
		setAnchors: function () {
			var t = this;
	
			t.$links.each(function (i) {
				var name = $(this).data("nav");
				var $target = $('section[data-nav="' + name + '"]');
				if ($target.length) {
					t.relations[name] = {
						link: $(this),
						section: $target,
						isActive: false,
					};
					if (i === 0) {
						t.actNav = t.relations[name];
					}
				} else {
					// console.error('<section> width attribute \'data-nav="' + name + '"\' not found');
				}
			});
		},
	
		setRelationsPos: function () {
			var t = this;
			for (var i in t.relations) {
				var relation = t.relations[i];
				relation.pos = relation.section.offset().top;
			}
		},
	
		setClasses: function () {
			var t = this;
	
			for (var i in t.relations) {
				var relation = t.relations[i];
				var checkPos = relation.pos - t.screenHeight * 0.56;
				if (t.scrollPos > checkPos) {
					t.actNav = relation;
				}
			}
	
			if (!t.actNav) {
				return false;
			}
	
			if (!t.actNav.isActive) {
				for (var e in t.relations) {
					t.relations[e].isActive = false;
				}
				t.actNav.isActive = true;
	
				var actText = t.actNav.link.text();
				t.mobile.$name.text(actText);
				t.$links.removeClass("is-active");
				t.$links.attr("aria-current", "false");
				t.actNav.link.addClass("is-active");
				t.actNav.link.attr("aria-current", "true");
			}
		},
	
		scrollToSection: function (name) {
			var t = this;
			if (typeof t.relations[name] !== "undefined") {
				var comp = t.$el.height();
				TweenLite.to(window, 0.9, {
					scrollTo: t.relations[name].section.offset().top - comp - 40,
					ease: Power2.easeInOut,
				});
				t.setMobileNav("close");
			} else {
				console.error(
					"<section> width attribute 'data-nav=\"" + name + "\"' not found"
				);
			}
		},
	
		setMobileNav: function (to) {
			if (to === "open") {
				this.$el.addClass("is-open");
				this.mobileTriggerAria(true);
				this.$container.fadeIn(300);
			} else if (to === "close") {
				this.$el.removeClass("is-open");
				this.mobileTriggerAria(false);
				this.$container.fadeOut(300);
			}
		},
	
		scrollEvent: function () {
			var t = this;
			t.setVariables();
			t.setClasses();
		},
	
		scrollEventListener: function () {
			var t = this;
			var to;
			$(window).on("scroll", function () {
				clearTimeout(to);
				to = setTimeout(function () {
					t.scrollEvent();
				}, 5);
			});
			$(window).trigger("scroll");
		},
	
		scrollToSectionEventListner: function () {
			var t = this;
			t.$links.on("click", function () {
				var name = $(this).data("nav");
				t.scrollToSection(name);
				return false;
			});
		},
	
		fixEventListener: function () {
			var t = this;
			$(window).on("resize load", function () {
				t.setAnchors();
				t.setRelationsPos();
				t.setClasses();
			});
		},
	
		mobileTriggerAria: function (opening) {
			this.mobile.$open.attr("aria-expanded", opening ? "true" : "false");
			this.mobile.$close.attr("aria-expanded", opening ? "true" : "false");
			if (opening) {
				this.mobile.$open.attr("disabled", "disabled");
				this.mobile.$close.removeAttr("disabled");
			} else {
				this.mobile.$open.removeAttr("disabled");
				this.mobile.$close.attr("disabled", "disabled");
			}
		},
	
		mobileTriggerEventListener: function () {
			var t = this;
			t.mobile.$open.on("click", function () {
				t.setMobileNav("open");
			});
			t.mobile.$close.on("click", function () {
				t.setMobileNav("close");
			});
		},
	};
	
	window.form = {};
	function niceSelect($el) {
		this.$el = $el;
	
		// data
		var data = $el.data();
		this.placeholder = data["placeholder"];
		this.single = data["single"] == true ? true : false;
	
		this.init();
	}
	
	niceSelect.prototype = {
		constructor: niceSelect,
		unqiueIdCounter: 0,
	
		init: function () {
			this.initMultiselect();
		},
	
		resetToPlaceholder: function () {
			var self = this;
			var ph = $(this.$el).data("placeholder");
			setTimeout(function () {
				$(self.$el).next().find("button").text(ph);
			});
		},
	
		initMultiselect: function () {
			var self = this;
			this.name = this.$el.attr("name");
	
			var minSelect = 0;
			var maxSelect = 100;
			if (self.single) {
				minSelect = 1;
				maxSelect = 1;
			}
	
			// this.$el.val = {};
			window.form[this.name] = [this.$el[0].value];
			var selectall = this.$el.attr("data-selectall") ? true : false;
	
			this.$el.multiselect({
				minHeight: 50,
				minSelect: minSelect,
				maxSelect: maxSelect,
				multiple: maxSelect === 1 ? false : true,
				selectAll: selectall,
				texts: {
					placeholder: self.placeholder,
					// selectedOptions: this.$el.data('selected') + ' ',
					selectedOptions: self.placeholder + " (",
					selectAll: this.$el.attr("data-selectall"),
				},
				onLoad: function (el) {
					const btn = $(el).next().find("button");
					const list = $(el).next().find("ul");
					const listItems = list.find("li");
					const label = $(el).prev(".js-select-button-label");
					const listInputs = list.find("input");
					const optionsWrap = btn.parent();
	
					console.log("listInputs", listInputs);
	
					// add id to list
					list.attr("id", "nice-select-list-" + sanitizeId(self.name));
	
					// add a11y attributes
					btn.attr("role", "combobox");
					btn.attr("aria-owns", list.attr("id"));
					btn.attr("aria-expanded", "false");
					btn.attr("aria-haspopup", "listbox");
					btn.attr("type", "button");
					// if there is a label, set aria-labelledby of the button to the label's id
					if (label.length > 0) {
						btn.attr("aria-labelledby", label.attr("id"));
					}
					list.attr("role", "listbox");
					list.attr("aria-multiselectable", "true");
					listItems.attr("role", "option");
	
					// on button click toggle aria-expanded
					btn.on("click", function () {
						var expanded =
							btn.attr("aria-expanded") === "true" ? "false" : "true";
						btn.attr("aria-expanded", expanded);
					});
	
					btn.on("keydown", function (e) {
						if (e.key === "ArrowDown" || e.key === "ArrowRight") {
							listInputs.first().focus();
						}
					});
	
					// on pressing down/right or up/left arrow key, focus on the next or previous one if it exists
					listInputs.on("keydown", function (e) {
						var current = $(this);
						var next = current.closest("li").next().find("input");
						var prev = current.closest("li").prev().find("input");
	
						if (
							(e.key === "ArrowDown" || e.key === "ArrowRight") &&
							next.length
						) {
							next.focus();
						} else if (
							(e.key === "ArrowUp" || e.key === "ArrowLeft") &&
							prev.length
						) {
							prev.focus();
						}
					});
	
					// on pressing escape key, if the list is open, close it by clicking the button
					optionsWrap.on("keydown", function (e) {
						if (e.key === "Escape" && btn.attr("aria-expanded") === "true") {
							btn.click();
						}
					});
				},
				onOptionClick: function (el, opt) {
					var isin = false;
					var newArr = [];
	
					window.form[self.name].map(function (item) {
						if (item !== opt.value) {
							newArr.push(item);
						} else {
							isin = true;
						}
					});
	
					if (opt.checked && !isin) {
						newArr.push(opt.value);
					}
	
					window.form[self.name] = newArr;
	
					if (self.single) {
						$(self.$el).next().find("button").removeClass("is-active");
						$(self.$el).next().find("button").next().css({
							display: "none",
						});
					}
	
					// if($(self.$el).parents('.js-center-list-form').length > 0){
					// 	self.resetToPlaceholder();
					// }
				},
			});
	
			setTimeout(function () {
				self.resetToPlaceholder();
			}, 100);
		},
	};
	
	function NiceCheckbox($el) {
		this.$el = $el;
	
		this.init();
	};
	
	NiceCheckbox.prototype = {
		init: function() {
			this.addElements();
		},
	
		addElements: function() {
			var t = this;
			var label = t.$el.attr('label');
			var name = t.$el.attr('name');
	
			t.$container = t.$el.wrap('<div class="niceCheckbox"></div>');
			t.$label = $('<label for="' + name + '" class="niceCheckbox__label">' + label + '</label>');
			t.$el.addClass('niceCheckbox__checkbox');
			t.$el.after(t.$label);
			t.$label.on('click', function() {
				t.$el[0].checked = !t.$el[0].checked;
				t.$el.trigger('change');
			});
		}
	
	};
	
	function NiceSearch($el) {
		this.$el = $el;
	
		this.init();
	}
	
	NiceSearch.prototype = {
		init: function () {
			this.addElements();
		},
	
		addElements: function () {
			var t = this;
			var label = t.$el.attr("label");
			var name = t.$el.attr("name");
	
			t.$container = t.$el.wrap('<div class="niceSearch"></div>');
			t.$el.before(
				'<label class="sr-only" for="' + name + '">' + label + "</label>"
			);
			t.$el.after(
				'<button type="submit" class="niceSearch__label  js-career-finder-submit">' +
					label +
					"</button>"
			);
			t.$inputBox = t.$el.wrap('<div class="niceSearch__inputbox"></div>');
			t.$el.addClass("niceSearch__input");
	
			$(".js-career-finder-submit").on("click", function () {
				$(".js-career-finder-submit").parents("form").submit();
			});
		},
	};
	
	(function($) {
	    var re = /([^&=]+)=?([^&]*)/g;
	    var decode = function(str) {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    };
	    $.parseParams = function(query) {
	        var params = {}, e;
	        if (query) {
	            if (query.substr(0, 1) == '?') {
	                query = query.substr(1);
	            }
	
	            while (e = re.exec(query)) {
	                var k = decode(e[1]);
	                var v = decode(e[2]);
	                if (params[k] !== undefined) {
	                    if (!$.isArray(params[k])) {
	                        params[k] = [params[k]];
	                    }
	                    params[k].push(v);
	                } else {
	                    params[k] = v;
	                }
	            }
	        }
	        return params;
	    };
	})(jQuery);
	
	
	
	function centerList($el) {
		this.$el = $el;
	
		this.$view = $el.find(this.classes.view);
		this.$viewButton = $el.find(this.classes.viewButton);
		this.$form = $el.find(this.classes.form);
		this.$container = $el.find(this.classes.container);
		this.$reset = $el.find(this.classes.reset);
		this.$count = $el.find(this.classes.count);
		this.$filterToggle = $el.find(this.classes.filterToggle);
		this.$filters = $el.find(this.classes.filters);
		this.$select = this.$form.find('select');
		this.$sortorder = $(this.classes.sortorder);
		this.$bodytext = $(this.classes.bodytext);
		this.$hyperOpeninghours = $(this.classes.hyperOpeninghours);
	
		// vars
		this.currentView = 'grid';
		this.ajaxCall = undefined;
		this.ajaxUrl = $el.data('ajaxUrl');
		this.resultsLoading = false;
		this.viewShown = false;
		this.firstTime = true;
	
		this.init();
	};
	
	centerList.prototype = {
		constructor: centerList,
	
		classes: {
			view: '.js-center-list-view',
			viewButton: '.js-center-list-view-button',
			form: '.js-center-list-form',
			container: '.js-center-list-container',
			reset: '.js-center-list-reset',
			count: '.js-center-list-count',
			filters: '.js-center-list-filters',
			filterToggle: '.js-center-list-filter-toggle',
			sortorder: '.js-portfolio-sortorder',
			bodytext: '.js-portfolio-bodytext-wrap',
			hyperOpeninghours: '.js-hyper-openinghours'
		},
	
		init: function(){
			this.initListeners();
		},
	
		triggerChange: function(t){
			t.selectChangeHandler(true);
		},
	
		initListeners: function(){
			this.$viewButton.on('click', {self: this}, this.viewButtonClickHandler);
			this.$reset.on('click', {self: this}, this.resetClickHandler);
			this.$filterToggle.on('click', {self: this}, this.filterToggleClickHandler);
			this.$select.on('change', {self: this}, this.selectChangeHandler);
			this.$sortorder.on('change', {self: this}, this.selectChangeHandler);
	
			this.$hyperOpeninghours.on('mouseover', {self: this}, this.showHyperOpeninghours)
			this.$hyperOpeninghours.on('mouseout', {self: this}, this.removeHyperOpeninghours)
	
			var t = this;
			this.$el.on('triggerchange', function(){
				t.triggerChange(t);
			});
		},
	
		showHyperOpeninghours: function(event){
	
			var openinghours = $(event.currentTarget).data('openinghours');
	
			var ovl = '<div class="ovl-openinghours"><div class="title">' + $(event.currentTarget).data('openinghours-translation') + ':</div>';
			for(var i=0; i<openinghours.length; i++){
				ovl += '<div class="ovl-openinghours__item">' + (openinghours[i]['weekdays'] ? '<span>' + openinghours[i]['weekdays'] + ':</span> ' : '') + '' + openinghours[i]['times'] + '</div>';
			}
			ovl += '</div>';
	
			$(event.currentTarget).append(ovl);
	
		},
	
		removeHyperOpeninghours: function(event){
	
			$(event.currentTarget).find('.ovl-openinghours').remove();
	
		},
	
		viewButtonClickHandler: function(event){
	
			$('.js-portfoliolist-local').remove();
			$('.js-portfoliolist-global').removeClass('hidden');
	
			var self = event.data.self;
			self.currentView = $(this).data('view');
	
			$('.js-center-list-view-button').addClass('is-disabled');
			$(this).removeClass('is-disabled');
	
			// trigger list
			self.selectChangeHandler();
	
		},
	
		selectChangeHandler: function(force){
	
			var x = this.$form;
			var self = this;
			var forced_sort_val = false;
	
			if(typeof x === 'undefined' && force !== true){
				x = force.data.self.$form;
				self = force.data.self;
	
				$('.js-portfoliolist-local').remove();
				$('.js-portfoliolist-global').removeClass('hidden');
	
				if(event){
					var $target = $(event.target);
					if($target.parents('.js-portfolio-sortorder-wrapper').length > 0) forced_sort_val = $target.val();
				}
			}
	
			self.sortLists(forced_sort_val);
	
			// hide bodytext when filtering the first time
			if(self.firstTime){
				self.firstTime = false;
			} else {
				self.$bodytext.hide(0);
			}
	
			var formData = x.serialize();
			var formData_encoded = $.parseParams(formData);
	
			if(typeof force !== 'undefined' && force === true){
				formData_encoded.force = true;
			}
	
			formData_encoded.view = self.currentView;
	
			// trigger list
			$('.js-portfolioList').trigger('filter', formData_encoded);
			// trigger map
			$('.js-portfolioMap').trigger('filter', formData_encoded);
		},
	
		sortLists: function(forced_val){
			var sort = (typeof forced_val !== 'undefined' && forced_val !== false) ? forced_val : $('select[name=sortorder]').val();
	
			$('select[name=sortorder] option').attr('selected', false);
			$('select[name=sortorder] option[value="' + sort + '"]').attr('selected', 'selected');
			
			var sel = $('select[name=sortorder]').next().find('input[value="' + sort + '"]').first();
			var sel_text = sel.parent().text();
	
			$('select[name=sortorder]').next().find('> button').text(sel_text);
			$('select[name=sortorder]').next().find('.ms-reflow').removeClass('selected');
			sel.parents('li').addClass('selected');
	
			
			$('.js-category-block').each(function(){
	
				var mylist = $(this).find('.portfolio__list__block').first();
				if(mylist.find('.center-list__table').length > 0) mylist = mylist.find('.center-list__table').first();
	
				var listitems = mylist.find('.js-portfolio-element').get();
				listitems.sort(function(a, b) {
	
					if(sort == 'nr'){
						var a_val = Number($(a).attr('data-counter'));
						var b_val = Number($(b).attr('data-counter'));
					} else {
						var a_val = (typeof $(a).attr('data-name') !== 'undefined') ? $(a).attr('data-name') : 'ZZZ';
						var b_val = (typeof $(b).attr('data-name') !== 'undefined') ? $(b).attr('data-name') : 'ZZZ';
					   a_val = a_val.toLowerCase();
					   b_val = b_val.toLowerCase();
					}
	
					if(sort == 'nr') return (a_val < b_val) ? -1 : (a_val > b_val) ? 1 : 0;
					if(sort == 'asc') return (a_val < b_val) ? -1 : (a_val > b_val) ? 1 : 0;
					if(sort == 'desc') return (a_val > b_val) ? -1 : (a_val < b_val) ? 1 : 0;
				});
	
				$.each(listitems, function(idx, itm) { mylist.append(itm); });
	
				if(mylist.find('.smallprint') > 0) mylist.find('.smallprint').appendTo(mylist);
	
			});
	
		},
	
		syncMapFilter: function() {
			var selection = this.$form.find('[name="status[]"]').val();
	
			$('.js-google-map-filter').each(function(){
				var isInListFilterSelection = ($.inArray($(this).data('type').toString(), selection) >= 0);
	
				if ( (isInListFilterSelection && !$(this).hasClass('is-active')) || (!isInListFilterSelection && $(this).hasClass('is-active')) ){
					$(this).trigger('click', true);
				}
			});
		},
	
		resetClickHandler: function(event){
			var self = event.data.self;
			self.resetForm();
	
			$('.js-center-list-filter-toggle .count').text('(0)');
	
			// trigger list
			$('.js-portfolioList').trigger('reset');
			// trigger map
			$('.js-portfolioMap').trigger('reset');
		},
	
		filterToggleClickHandler: function(event){
			var self = event.data.self;
	
			if( $(this).hasClass('is-active') ){
				$(this).removeClass('is-active');
				$(this).attr('aria-expanded', 'false');
				self.$filters.hide();
			} else {
				$(this).addClass('is-active');
				$(this).attr('aria-expanded', 'true');
				self.$filters.show();
			}
		},
	
		showView: function(view){
			var self = this;
			var $previousView = self.$view.filter('[data-view="'+ self.currentView +'"]');
			var $newView = self.$view.filter('[data-view="'+ view +'"]');
	
			// mark buttons
			var $previousButton = self.$viewButton.filter('[data-view="'+ self.currentView +'"]');
			var $newButton = self.$viewButton.filter('[data-view="'+ view +'"]');
			$previousButton.addClass('is-disabled');
			$newButton.removeClass('is-disabled');
	
			this.currentView = view;
			TweenLite.to($previousView, 0.2, {opacity: 0, y: 10, ease: Power2.easeOut, onComplete: function(){
				$previousView.removeClass('is-active');
				$newView.addClass('is-active');
				TweenLite.to($newView, 0.2, {opacity: 1, y: 0, ease: Power2.easeIn});
			}});
	
		},
	
		resetForm: function(){
			var self = this;
			var selectCount = this.$select.length;
			var i = 0;
	
			this.$select.each(function(){
				i++;
	
				$(this).find('option:selected').prop("selected", false);
				$(this).find('.defaultval').attr('selected', 'selected');
	
				$(this).multiselect( 'reload' );
	
				if(selectCount == i){
					$(this).trigger('change');
				}
			});
		},
	
	
	}
	function downloadList($el) {
		this.$el = $el;
	
		this.elements = {
	
			container: $el.find(".js-download-list__items"),
			items: $el.find(".js-download-list__item"),
			preloader: $el.find(".js-download-list__preloader"),
			pagination: $el.find(".js-download-list__pagination"),
			naviTitle: $el.find(".js-download-list__navi-title"),
	
			filterCategory: $el.find(".ms-reflow input[type='checkbox']"),
	
			categories: [],
			months: false,
			years: false,	
		};
	
		
		this.init();
	}
	
	downloadList.prototype = {
		constructor: downloadList,
	
		
		init: function () {
			//this.initArrays();
			this.initListeners();
	
			var y_placeholder = $('select[name=year]').data('placeholder');
			var m_placeholder = $('select[name=month]').data('placeholder');
			var c_placeholder = $('select[data-type=category]').data('placeholder');
	
			$('select[name=year]').next().find('button').text(y_placeholder);
			$('select[name=month]').next().find('button').text(m_placeholder);
			$('select[data-type=category]').next().find('button').text(c_placeholder);
	
			$('select[name=year]').next().find('li').removeClass('default').removeClass('selected');
			$('select[name=month]').next().find('li').removeClass('default').removeClass('selected');
			$('select[data-type=category').next().find('li').removeClass('default').removeClass('selected');
		},
	
		initListeners: function () {
			$(document).on('click', '.js-download-list__page-number', this.pageClick.bind(this))
			this.elements.filterCategory.on("click", this.filterClick.bind(this));
		},
	
	
		// update arrays because checkboxes can be active on page load
		initArrays: function () {
			var selectedCheckboxes =  this.$el.find('.ms-reflow.selected');
			var self = this;
	
			$.each(selectedCheckboxes, function(key, item ) {
				var $item = $(item);
	
				var inputValue = $item.find("input[type='checkbox']")[0].value;
				var inputType =  $item.closest('.ms-options-wrap')[0].previousSibling.dataset.type;
	
				switch (inputType) {
					case 'category':
		
						var index = self.elements.categories.indexOf(inputValue);    // <-- Not supported in <IE9
						if (index !== -1) {
							self.elements.categories.splice(index, 1);
						} else {
							self.elements.categories.push(inputValue)
						}
			
						break;
				
					// case 'month':
					// 	var index = self.elements.months.indexOf(inputValue);    // <-- Not supported in <false9
					// 	if (index !== -1){
					// 		self.elements.months.splice(index, 1);
					// 	} else {
					// 		self.elements.months.push(inputValue)
					// 	}
		
					// 	break;
		
					// case 'year':
					// 	var index = self.elements.years.indexOf(inputValue);    // <-- Not supported in <IE9
					// 	if (index !== -1) {
					// 		self.elements.years.splice(index, 1);
					// 	} else {
					// 		self.elements.years.push(inputValue)
					// 	}
		
					// 	break;
				
					default:
						break;
				}
		
			});
	
		},
	
		pageClick: function (e) {
			e.preventDefault();
	
			var pageIndex = e.target.dataset.index
			this.loadList(pageIndex, false);
		},
	
		filterClick: function(e) {
			var clickedInput = e.target;
			var clickedInputValue = e.target.value;
			var clickedType = clickedInput.closest('.ms-options-wrap').previousSibling.dataset.type;
		
	
			// working with arrays to send them via ajax
			// choosing the array by swithc
			switch (clickedType) {
				case 'category':
	
					var index = this.elements.categories.indexOf(clickedInputValue);    // <-- Not supported in <IE9
	
					// if value is here remove it.
					if (index !== -1) {
						this.elements.categories.splice(index, 1);
					} else {
						this.elements.categories.push(clickedInputValue)
					}
	
					break;
			
				case 'month':
					this.elements.months = clickedInputValue;
					break;
	
				case 'year':
					this.elements.years = clickedInputValue;
					break;
			
				default:
					break;
			}
	
	
	
			var pageIndex = 0;
			this.loadList( pageIndex, true ); 
	
		},
	
		loadList: function (pageIndex, filterChange) {
			var url = this.$el.data("api-url");
	
			// show preloader
			this.elements.preloader.removeClass('is-not-visible');
	
			
	
			var that = this;
			$.ajax({
				url: url,
				method: 'get',
				data: {
					pageNumber: pageIndex,
					categories: that.elements.categories,
					months: that.elements.months,
					years: that.elements.years,
					filterChange: filterChange, //check if this was changed with filter or just page click
				}
				
			}).done(function(response){
				response = JSON.parse(response)
	
				var items = response.items;
				var activePage = response.activePage;
				var naviTitle = response.naviTitle;
	
				// hide preloader
				that.elements.preloader.addClass('is-not-visible');
	
	
				that.elements.naviTitle.html(naviTitle);
				that.elements.container.html(items);
				that.$el.find(".js-download-list__page-number.is-active").removeClass('is-active');
				that.$el.find(".js-download-list__page-caption.is-active").removeClass('is-active');
	
				if(typeof response.pagination !== 'undefined'){
					$('.js-download-list__pagination').empty();
					response.pagination.forEach(function(e){
						$('.js-download-list__pagination').append('<a href="#" class="download-list__pagination-item js-download-list__page-number" data-index="' + e.number + '">' + e.number + '</a>');
					});
				}
	
				that.$el.find(".js-download-list__page-number[data-index='" + activePage + "']").addClass('is-active');
				that.$el.find(".js-download-list__page-caption[data-index='" + activePage + "']").addClass('is-active');
			});
		},
	
	};
	
	function Timeline($el) {
		this.$el = $el;
		this.$events = $('.timeline__event', $el);
		this.$stage = $('.timeline__stage', $el);
	
		this.options = {
			width: 420,
			padding_left: 100,
			padding_right: 100,
			height: 560
		};
	
		this.mouseDownPoint = 0;
		this.lastPointTmp = 0;
		this.lastPoint = 0;
	
		this.elWidth = $el.width();
		this.stageWidth = this.$stage.width();
	
		this.$el.height(this.options.height);
		this.$stage.height(this.options.height);
		this.init();
	};
	
	Timeline.prototype = {
		init: function() {
			this.positionEvents();
			this.addEventListeners();
		},
	
		positionEvents: function() {
			var t = this;
			var posLeft = t.options.padding_left;
			var top = true;
	
			// t.$events.width(t.options.width);
			t.$events.each(function() {
				var $t = $(this);
				var posTop = 'auto';
				var posBottom = t.options.height / 2;
				var posClass = 'timeline__event--top';
	
				if (!top) {
					posTop = t.options.height / 2;
					posBottom = 'auto';
					posClass = 'timeline__event--bottom';
				}
	
				$t.css({
					'width': t.options.width,
					'left': posLeft + 'px',
					'top': posTop,
					'bottom': posBottom
				}).addClass(posClass);
	
				top = !top;
				posLeft += (t.options.width * 0.9);
			});
	
			t.stageWidth = posLeft + (t.options.width * 0.1) + t.options.padding_right;
			t.$stage.width(t.stageWidth);
		},
	
		addEventListeners: function() {
			var t = this;
			var move = false;
			var allOffsetX = 0;
	
			t.$stage.on('touchstart mousedown', function(e) {
				if (!move) {
					var x = e.pageX || e.originalEvent.touches[0].pageX;
					t.lastPoint = t.lastPointTmp;
					allOffsetX = t.$el.offset().left;
					t.mouseDownPoint = x - allOffsetX;
					t.elWidth = t.$el.innerWidth();
					t.removeEasingClass();
					move = true;
				} else {
					move = false;
				}
			});
			$(window).on('mousemove', function(e) {
				if (move) {
					var x = e.pageX || e.originalEvent.touches[0].pageX;
					t.removeEasingClass();
					t.moveStage(x - allOffsetX);
				}
			}).on('touchend mouseup', function() {
				move = false;
				t.lastPoint = t.lastPointTmp;
				t.resetPosition();
			});
			t.$stage[0].addEventListener('touchmove', function listener(e) {
				if (move) {
					var x = e.pageX || undefined;
					if (typeof e.originalEvent !== 'undefined') {
						x = e.originalEvent.touches[0].pageX;
					}
					if (typeof e.targetTouches !== 'undefined') {
						x = e.targetTouches[0].clientX;
					}
					t.removeEasingClass();
					t.moveStage(x - allOffsetX);
				}
			}, {
				passive: true
			});
	
			$('html').on('mouseleave', function() {
				move = false;
				t.lastPoint = t.lastPointTmp;
				t.resetPosition();
			});
			$('widnow').on('blur', function() {
				move = false;
				t.lastPoint = t.lastPointTmp;
				t.resetPosition();
			});
	
			var to;
			$(window).on('resize', function() {
				clearTimeout(to);
				to = setTimeout(function() {
					t.resetPosition();
				}, 120);
			});
		},
	
		moveStage: function(to) {
			var t = this;
			if (to === 'same') {
				to = t.lastPoint;
			}
			var moveTo = t.lastPoint + (to - t.mouseDownPoint);
	
			if (moveTo > 0) {
				moveTo = ((moveTo / t.elWidth) * 0.3) * t.elWidth;
	
			} else if (moveTo < t.elWidth - t.stageWidth) {
				var base = t.elWidth - t.stageWidth;
				var over = moveTo - base;
				moveTo = base + (over * 0.3);
			}
	
			moveTo = Math.round(moveTo);
	
			t.$stage.attr('style', '\
				transform: translateZ(0) translateX(' + moveTo + 'px); \
				-webkit-transform: translateZ(0) translateX(' + moveTo + 'px); \
				-moz-transform: translateZ(0) translateX(' + moveTo + 'px); \
				-ms-transform: translateZ(0) translateX(' + moveTo + 'px); \
				width: ' + t.stageWidth + 'px');
			t.lastPointTmp = moveTo;
	
			$(document).trigger('scroll');
		},
	
		resetPosition: function() {
			var t = this;
			t.elWidth = t.$el.innerWidth();
	
			if (t.lastPoint > 0) {
				t.addEasingClass();
				var np = 0;
				t.$stage.attr('style', '\
					transform: translateZ(0) translateX(' + np + 'px); \
					-webkit-transform: translateZ(0) translateX(' + np + 'px); \
					-moz-transform: translateZ(0) translateX(' + np + 'px); \
					-ms-transform: translateZ(0) translateX(' + np + 'px); \
				width: ' + t.stageWidth + 'px');
				t.lastPoint = 0;
				t.lastPointTmp = 0;
			} else if (t.lastPoint < t.elWidth - t.stageWidth) {
				t.addEasingClass();
				var np = t.elWidth - t.stageWidth;
				t.$stage.attr('style', '\
					transform: translateZ(0) translateX(' + np + 'px); \
					-webkit-transform: translateZ(0) translateX(' + np + 'px); \
					-moz-transform: translateZ(0) translateX(' + np + 'px); \
					-ms-transform: translateZ(0) translateX(' + np + 'px); \
				width: ' + t.stageWidth + 'px');
				t.lastPoint = np;
				t.lastPointTmp = np;
			}
		},
	
		addEasingClass: function() {
			this.$stage.addClass('timeline__stage--ease');
		},
		removeEasingClass: function() {
			this.$stage.removeClass('timeline__stage--ease');
		}
	};
	
	var Tabs = function ($el) {
		this.$el = $el;
		this.$swipers = $(".js-simple-swiper", $el);
	
		this.$nav = $(".tabs__nav", $el);
		this.$navPoints = $(".tabs__nav__link", $el);
		this.$content = $(".tabs__content", $el);
		this.$quoteContent = $(".js-quote__block", $el);
		this.$contentPart = $(".tabs__content__part", $el);
	
		this.$slider = $(".tabs__nav__border__slider", $el);
	
		this.init();
	};
	
	Tabs.prototype = {
		init: function () {
			var t = this;
	
			t.makeSwipers();
			t.manageTabs();
			t.initTabs();
	
			if ($(".tabs__nav__border__slider")) {
				t.setBarPos();
			}
	
			t.barClickEvent();
	
			$(window).on("resize", function () {
				if ($(".tabs__nav__border__slider")) {
					t.setBarPos();
				}
			});
		},
	
		manageTabs: function () {
			var t = this;
	
			t.$navPoints.on("click", function () {
				var $t = $(this);
				var i = $t.prevAll(".tabs__nav__link").length;
	
				var $cPart = $(t.$contentPart[i]);
	
				return false;
			});
		},
	
		barClickEvent: function () {
			var $quoteContent = $("body").find(".js-quote__block");
			var t = this;
			t.$navPoints.on("click", function () {
				$siblings = $(this).siblings(".tabs__nav__link");
	
				$siblings.removeClass("is-active");
				$siblings.attr("aria-selected", "false");
				$siblings.attr("tabindex", "-1");
	
				$(this).addClass("is-active");
				$(this).attr("aria-selected", "true");
				$(this).attr("tabindex", "0");
	
				if ($(".tabs__nav__border__slider")) {
					t.setBarPos();
				}
	
				var i = $(this).prevAll().length;
	
				$quoteContent.each(function () {
					$(this).removeClass("is-active");
					$(this).css({
						height: 0,
						opacity: 0,
						"z-index": "-400",
					});
				});
	
				$(t.$quoteContent[i]).addClass("is-active");
	
				$(t.$contentPart[i])
					.css({
						height: "auto",
						opacity: 1,
						"z-index": "1",
					})
					.siblings()
					.css({
						height: 0,
						opacity: 0,
						"z-index": "-400",
					});
	
				$(t.$contentPart[i])
					.attr("aria-hidden", "false")
					.siblings()
					.attr("aria-hidden", "true");
	
				t.$swipers.each(function () {
					if (this.swiper) {
						this.swiper.slideTo(1, 0);
						this.swiper.startAutoplay();
					}
				});
			});
	
			// when focused on navPoints and pressing left or right arrow key, focus on the next or previous one if it exists
			t.$navPoints.on("keydown", function (event) {
				event.stopPropagation();
	
				var $this = $(this);
				var $prev = $this.prev();
				var $next = $this.next();
	
				if (event.key === "ArrowLeft") {
					if ($prev.length) {
						$prev.focus();
					} else {
						t.$navPoints.last().focus();
					}
				} else if (event.key === "ArrowRight") {
					if ($next.length) {
						$next.focus();
					} else {
						t.$navPoints.first().focus();
					}
				}
			});
		},
	
		setBarPos: function () {
			var t = this;
			var $act = t.$navPoints.filter(".is-active");
	
			const position = $act.position();
			if (typeof position !== "undefined") {
				t.$slider.css({
					left: $act.position().left,
					width: t.$slider.hasClass("tabs__nav__border__slider--fullwidth")
						? $act.width()
						: $act.width() * 0.5,
				});
			}
		},
	
		initTabs: function () {
			var t = this;
	
			t.$contentPart
				.first()
				.nextAll()
				.css({
					height: 0,
					opacity: 0,
					"z-index": "-400",
				})
				.attr("aria-hidden", "true");
			t.$contentPart.first().attr("aria-hidden", "false");
	
			t.$navPoints.first().addClass("is-active");
			t.$navPoints.attr("aria-selected", "false");
			t.$navPoints.first().attr("aria-selected", "true");
			t.$navPoints.attr("tabindex", "-1");
			t.$navPoints.first().attr("tabindex", "0");
		},
	
		makeSwipers: function () {
			var t = this;
	
			t.$swipers.each(function () {
				var $container = $(this);
				var $wrapper = $container.children().first();
				var $slides = $wrapper.children();
	
				var $pagination = $(
					'<div class="swiper-pagination swiper-pagination--down swiper-pagination--center"></div>'
				);
				var $pagination_fraction = $(
					'<div class="swiper-pagination-fraction-wrapper"><span class="swiper-fraction-prev icon--point_left"></span><div class="swiper-pagination swiper-pagination--center"></div><span class="swiper-fraction-next icon--point_right"></span></div>'
				);
	
				$container.addClass("swiper-container");
				$wrapper.addClass("swiper-wrapper");
				$slides.addClass("swiper-slide");
	
				if ($container.hasClass("js-simple-swiper--fullwidth")) {
					$container.append($pagination_fraction);
	
					if ($container.find(".swiper-slide").length > 0) {
						var autoplay = 3000;
						var loop = true;
						if ($container.find(".swiper-slide").length < 2) {
							autoplay = false;
							loop = false;
						}
	
						t.swiper = new Swiper($container, {
							a11y: swiperA11yOptions,
							keyboardControl: true,
	
							pagination: ".swiper-pagination",
							paginationType: "fraction",
	
							nextButton: ".swiper-fraction-next",
							prevButton: ".swiper-fraction-prev",
	
							autoHeight: true,
	
							speed: 500,
							parallax: true,
	
							slidesPerView: 1,
							spaceBetweenSlides: 0,
	
							autoplay: autoplay,
							loop: loop,
	
							onSlideChangeEnd: function (swiper) {
								$(window).trigger("scroll");
							},
						});
					} else {
						$container.find(".swiper-pagination-fraction-wrapper").hide();
					}
				} else {
					$container.append($pagination);
					t.swiper = new Swiper($container, {
						a11y: swiperA11yOptions,
						keyboardControl: true,
						pagination: $pagination,
						paginationClickable: true,
						//autoHeight: true,
						speed: 500,
						bulletActiveClass: "active",
						parallax: true,
						bulletClass: "bullet",
	
						autoplay: 3000,
						loop: true,
	
						breakpoints: {
							480: {
								slidesPerView: 1,
								spaceBetweenSlides: 0,
							},
							740: {
								slidesPerView: 2,
								spaceBetweenSlides: 0,
							},
							1200: {
								slidesPerView: 3,
								spaceBetweenSlides: 0,
							},
							1920: {
								slidesPerView: 4,
								spaceBetweenSlides: 0,
							},
						},
	
						onSlideChangeEnd: function (swiper) {
							$(window).trigger("scroll");
						},
					});
				}
			});
		},
	};
	
	var Voices = function ($el) {
		this.$el = $el;
		this.$people = $(".voices__person", $el);
		this.$quotes = $(".voices__quote", $el);
		this.$quotes_container = $(".voices__quotes", $el);
		this.$close = $(".voices__quotes__close", $el);
	
		this.clicked = false;
		this.rndCache = "";
		this.relations = [];
	
		this.init();
	};
	
	Voices.prototype = {
		init: function () {
			var t = this;
			this.setupRelations();
	
			var voicesInerval = setInterval(function () {
				t.randomPreview();
			}, 6e3);
			t.randomPreview();
	
			this.personClickEvent();
			this.closeClickEvent();
	
			t.$el.addClass("voices_count_" + this.$people.length);
		},
	
		setupRelations: function () {
			var t = this;
			t.relations.length = 0;
	
			t.$people.each(function () {
				var id = $(this).data("voice");
				t.relations[id] = {
					$profile: $(this),
					$quote: $(t.$quotes[id]),
				};
			});
		},
	
		openQuote: function (num) {
			var t = this;
			t.relations[num].$profile
				.attr("aria-selected", "true")
				.siblings()
				.attr("aria-selected", "false");
			t.relations[num].$quote
				.attr("aria-hidden", "false")
				.siblings()
				.attr("aria-hidden", "true");
			t.$quotes_container.addClass("is-visible");
	
			// if ($(window).width() < 560) {
			// 	$('html, body').animate({
			// 		scrollTop: t.$quotes_container.offset().top - 60
			// 	}, 300);
			// }
		},
	
		closeQuote: function () {
			this.$people.attr("aria-selected", "false");
			this.$quotes.attr("aria-hidden", "true");
			this.$quotes_container.removeClass("is-visible");
		},
	
		randomPreview: function () {
			if ($(window).width() > 905 && !this.clicked) {
				var rnd = Math.floor(Math.random() * this.$people.length);
				if (this.rndCache.split("-").length === this.$people.length + 1) {
					this.rndCache = "";
				}
				if (this.rndCache.indexOf("-" + rnd) === -1) {
					this.openQuote(rnd);
					this.rndCache = this.rndCache + "-" + rnd;
				} else {
					this.randomPreview();
				}
			}
		},
	
		personClickEvent: function () {
			var t = this;
			this.$people.on("click", function () {
				var id = $(this).data("voice");
				t.clicked = true;
				t.openQuote(id);
	
				t.$people.attr("tabindex", "-1");
				$(this).attr("tabindex", "0");
	
				if (voicesInerval) clearInterval(voicesInerval);
			});
	
			this.$people.attr("tabindex", "-1");
			this.$people.first().attr("tabindex", "0");
	
			// on left and right arrow key press focus the prev or next item if possible
			this.$people.on("keydown", function (event) {
				var $this = $(this);
				var $prev = $this.prev();
				var $next = $this.next();
	
				if (event.key === "ArrowLeft" && $prev.length > 0) {
					$prev.focus();
				} else if (event.key === "ArrowRight" && $next.length > 0) {
					$next.focus();
				}
			});
		},
	
		closeClickEvent: function () {
			var t = this;
			this.$close.on("click", function () {
				t.closeQuote();
			});
		},
	};
	
	
	var VerticalList = function($el) {
		this.$el = $el;
		this.$items = $('.vertical_list__item', $el);
	
		this.animationTime = 500;
		this.init();
	};
	
	VerticalList.prototype = {
		init: function() {
			this.initialSetup();
			this.addClickEvent();
		},
	
		initialSetup: function() {
			$('.vertical_list__item__text__par--more', this.$el).slideUp(0);
			// $('.vertical_list__item__text__link', this.$el).each(function(){
			// 	// $(this).attr('originalText', )
			// });
		},
	
		addClickEvent: function() {
			var t = this;
	
			t.$items.each(function() {
				var $t = $(this);
	
				$t.on('click', function(){
					if(!$t.hasClass('is-active')){
						$t.addClass('is-active');
	
						var $short = $('.vertical_list__item__text__par', $t),
							$long = $('.vertical_list__item__text__par--more', $t);
	
						$short.slideUp(t.animationTime);
						$long.slideDown(t.animationTime);
	
						return false;
					}
				});
	
				$t.on('click', '.vertical_list__item__text__link', function() {
					$t.toggleClass('is-active');
					var $short = $('.vertical_list__item__text__par', $t),
						$long = $('.vertical_list__item__text__par--more', $t);
	
					// var altText = $link.attr('altText'),
					// 	currText = $link.text();
	
					$short.slideToggle(t.animationTime);
					$long.slideToggle(t.animationTime);
	
					// $link.text(altText).attr('altText', currText);
	
					return false;
				});
			});
		}
	};
	
	var ListGrid = function ($el) {
		this.$el = $el;
	
		this.$imageItems = $(".list-grid__item__image__item", $el);
		this.$imageC = $(".list-grid__item__image", $el);
	
		this.init();
	};
	
	ListGrid.prototype = {
		init: function () {
			this.makeSwipers();
		},
	
		makeSwipers: function () {
			var t = this;
	
			t.$imageC.each(function () {
				var $t = $(this);
	
				var $slides = $(".list-grid__item__image__item__bg", $(this));
				if ($slides.length > 1) {
					var $pagination = $(
						'<div class="swiper-pagination swiper-pagination--right"></div>'
					);
					$t.append($pagination);
	
					// this.$container.addClass('swiper-container');
					$t.addClass("swiper-container");
					$t.find(".list-grid__item__image__item").addClass("swiper-wrapper");
					$slides.addClass("swiper-slide");
	
					this.swiper = new Swiper($t, {
						a11y: swiperA11yOptions,
						keyboardControl: true,
						pagination: $pagination,
						paginationClickable: true,
						//autoHeight: true,
						speed: 500,
						bulletActiveClass: "active",
						parallax: true,
						bulletClass: "bullet",
	
						onSlideChangeEnd: function (swiper) {
							$(window).trigger("scroll");
						},
					});
				}
			});
		},
	};
	
	var Overlay = function($el) {
		this.$el = $el;
		this.cacheLocation = '';
		this.cacheTitle = '';
	
		this.animationSpeed = 300;
	
		this.init();
	};
	
	Overlay.prototype = {
		init: function() {
			var t = this;
			this.setupHTML();
			this.addClickListener();		
		},
	
		goback: function(force){
			var e = window.overlayscope;
			if (e.cacheLocation !== '' || force === true) {
				//console.log('123');
				$('title').text(e.cacheTitle);
				e.$ov.overlay.removeClass('visible');
	
				$('html').removeClass('gen_overlay--noscroll');
				$('body').css({
					'margin-top': 0 + 'px'
				});
				e.$ov.overlay.css({
					top: 'auto'
				});
				$(window).scrollTop(window.cacheScroll);
	
				e.$ov.overlay.fadeOut(e.animationSpeed);
				// setTimeout(function(){
				// }, 200);
				e.$ov.content.html('');
			}
		},
	
		setupHTML: function() {
			var t = this;
			if (window.popupHtmlPresent !== true) {
				var html = '\
						<div class="gen_overlay"> \
							<div class="gen_overlay__bg"></div>\
							<div class="gen_overlay__container"> \
								<div class="gen_overlay__container__close"> \
								</div> \
								<div class="gen_overlay__container__content"> \
								</div> \
							</div> \
						</div>';
						
				if($('.gen_overlay').length === 0) $('body').prepend(html);
				
				window.popupHtmlPresent = true;
	
				$(window).on('popstate', function() {
					t.goback();
					return false;
				});
			}
	
			this.$ov = {
				overlay: $('.gen_overlay'),
				overlayBg: $('.gen_overlay__bg'),
				container: $('.gen_overlay__container'),
				close: $('.gen_overlay__container__close'),
				content: $('.gen_overlay__container__content')
			};
	
		},
	
		addClickListener: function() {
			var t = this;
			t.$el.on('click', function() {
				var $t = $(this);
				var link = $t.attr('href');
				window.overlayscope = t;
				t.cacheTitle = $('title').text();
				t.cacheLocation = window.location.href;
	
				if (link.indexOf('http:') === -1) {
					link = window.location.protocol + '//' + window.location.host + '/' + link;
				}
				//t.$ov.content.load(link + ' .site-main', function(data) {
				t.$ov.content.load(link + ' .page_content', function(data) {
					var $data = $('<div>' + data + '</div>');
					var title = $('title', $data).text();
	
					if (typeof window.history.pushState !== 'undefined') {
						window.history.pushState({
							name: "overlay",
							urlPath: link
						}, title, link);
					} else {
						window.location.hash = 'overlay';
					}
	
					t.$ov.overlay.addClass('visible');
					t.$ov.overlay.fadeIn(t.animationSpeed);
	
					window.cacheScroll = $(window).scrollTop();
	
					$('html').addClass('gen_overlay--noscroll');
					$('body').css({
						'margin-top': window.cacheScroll*-1 + 'px'
					});
					t.$ov.overlay.css({
						top: window.cacheScroll
					});
					$(window).scrollTop(0);
	
					Main.initPlugins(t.$ov.overlay);
					$('*[data-src], *[data-bg]').lazyLoadXT();
					setTimeout(function(){
						$(window).trigger('resize');
					},8);
				});
	
				return false;
			});
	
			t.$ov.overlay.on('click', function(e){
				e.stopPropagation();
				//console.log('1');
				t.cloveOverlay();
			});
			t.$ov.container.on('click', function(e){
				e.stopPropagation();
			});
			t.$ov.close.on('click', function(e){
				e.stopPropagation();
				//console.log('3');
				t.cloveOverlay();
			});
		},
	
		cloveOverlay: function() {
			var t = this;
			//console.log('close ov');
			if (typeof window.history.pushState !== 'undefined') {
				window.history.pushState({
					name: "overview",
					urlPath: t.cacheLocation
				}, t.cacheTitle, t.cacheLocation);
			} else {
				window.location.hash = '';
			}
			t.goback(true);
		}
		
	};
	
	
	
	
	
	$(window).on("popstate", function () {		
		if(history.state.urlPath != "") {
			window.location.reload();
		} 
	});
	var Gallery = function ($el) {
		this.$el = $el;
		this.$images = $(".gallery__img__wrapper", $el);
		// this.$thumbs = $('.gallery__thumbs__img__wrapper', $el);
		// this.$thumbs_wrapper = $('.gallery__thumbs__wrapper', $el);
		this.clicked = false;
		this.rndCache = "";
		this.relations = [];
	
		this.$sw_container = $(".gallery__swiper", $el);
		this.$sw_wrapper = $(".gallery__swiper__wrapper", $el);
		this.$sw_slides = $(".gallery__img__wrapper", $el);
		this.$sw_pagination = $(".gallery__pagination", $el);
		this.swiper;
	
		this.smallGallery = $el.hasClass("is-small");
		this.init();
	};
	
	Gallery.prototype = {
		init: function () {
			var t = this;
			this.setupRelations();
	
			this.$sw_container.addClass("swiper-container");
			this.$sw_wrapper.addClass("swiper-wrapper");
			this.$sw_slides.addClass("swiper-slide");
	
			var swiperOptions = {
				a11y: swiperA11yOptions,
				keyboardControl: true,
				pagination: t.$sw_pagination,
				paginationClickable: true,
				autoHeight: false,
				speed: 500,
				bulletActiveClass: "active",
				slidesPerView: "auto",
				bulletClass: "bullet",
				centeredSlides: true,
				slideToClickedSlide: true,
				autoplay: 3000,
				loop: true,
	
				onSlideChangeStart: function (swiper) {
					var id = swiper.activeIndex;
					// t.relations[id].$thumb.addClass('is-active').siblings().removeClass('is-active');
	
					// t.scrollToActiveThumb(id);
				},
				onSlideChangeEnd: function (swiper) {
					$(window).trigger("scroll");
				},
				onInit: function (swiper) {
					// that.updateView();
				},
				breakpoints: {
					600: {
						autoplay: 3000,
						loop: true,
					},
				},
			};
	
			if (t.smallGallery) {
				swiperOptions.centeredSlides = false;
			}
			if (this.$sw_container.find(".swiper-slide").length > 2) {
				this.swiper = new Swiper(this.$sw_container, swiperOptions);
			}
	
			// this.$thumbs_wrapper.addClass('scrollbar-outer');
			// this.$thumbs_wrapper.scrollbar();
			// this.thumbClickEvent();
		},
	
		setupRelations: function () {
			var t = this;
			t.relations.length = 0;
			t.$images.each(function () {
				var id = $(this).data("gallery");
				t.relations[id] = {
					$image: $(this),
					// '$thumb': $(t.$thumbs[id])
				};
			});
		},
	
		showImage: function (num) {
			var t = this;
			t.swiper.slideTo(num);
			// t.relations[num].$thumb.addClass('is-active').siblings().removeClass('is-active');
		},
	
		// thumbClickEvent: function() {
		// 	var t = this;
		// 	this.$thumbs.on('click', function() {
		// 		var id = $(this).data('gallery');
		// 		t.clicked = true;
		// 		t.showImage(id);
		// 	});
		// },
	
		// scrollToActiveThumb: function(id) {
		// 	var t = this;
		// 	var wrapper_bottom = t.$thumbs_wrapper.offset().top + t.$thumbs_wrapper.height();
		// 	var element_bottom = t.relations[id].$thumb.offset().top + t.relations[id].$thumb.outerHeight();
	
		// 	var wrapper_top = t.$thumbs_wrapper.offset().top;
		// 	var element_top = t.relations[id].$thumb.offset().top;
		// 	var element_vertical_padding = (t.relations[id].$thumb.outerHeight() - t.relations[id].$thumb.height());
	
		// 	var wrapper_scroll = t.$thumbs_wrapper.scrollTop();
	
		// 	if (wrapper_bottom <= element_bottom) {
		// 		t.$thumbs_wrapper.animate({
		// 		        scrollTop: (element_bottom - wrapper_bottom) + wrapper_scroll
		// 		    }, 400);
		// 	}
		// 	else if (wrapper_top > element_top + element_vertical_padding ) {
		// 		t.$thumbs_wrapper.animate({
		// 		        scrollTop: (element_top - wrapper_top) + wrapper_scroll + element_vertical_padding
		// 		    }, 400);
		// 	}
		// }
	};
	
	function heroVideo($el) {
		this.$el = $el;
		this.$hero = $(".hero", $el);
		this.$hero_video = $(".video--hero", $el);
		this.hero_video_id = this.$hero_video.attr("id");
		this.$expanded_control_buttons = $(
			"[aria-controls=" + this.hero_video_id + "]"
		);
		this.$play_button = $(".hero__play-video", $el);
		this.$real_play_button = $(".video--hero .video__button a", $el);
		this.init();
	}
	heroVideo.prototype = {
		init: function () {
			var t = this;
			t.$play_button.on("click", function (e) {
				e.preventDefault();
				t.$expanded_control_buttons.attr("aria-expanded", "true");
	
				t.$hero.slideUp(500);
				t.$hero_video.slideDown(500);
	
				$("html, body").animate(
					{
						scrollTop:
							$(".site-header__inner").height() - $(".site-header").height(),
					},
					500
				);
	
				t.$real_play_button.click();
			});
		},
	};
	
	var landingMap = function($el) {
		this.$el = $el;
		this.$centerTriggers = $el.find('.js-landing-map-center-trigger');
		this.$centerClose = $el.find('.js-landing-map-close')
		this.init();
	};
	
	landingMap.prototype = {
		
		settings : {
			info_window_position_class_root : 'map__infobox--',
		},
		
		init: function() {
			var t = this;
			
			t.$centerTriggers.on('click', function(e) {
				e.preventDefault();
				$('.js-landing-map-center-target.is-visible').removeClass('is-visible');
	
				$('.js-landing-map-center-target[data-id='+$(this).data('id')+']').addClass('is-visible').addClass(t.get_infobox_class(this));
			
			});
			
			t.$centerClose.on('click', function(e) {
				e.preventDefault();
				$(this).parent().removeClass('is-visible');
			
			});
			
		},
		get_infobox_class: function(trigger) {
			
			var center_top =  parseFloat(trigger.style.top.replace('%',''));
			var center_left = parseFloat(trigger.style.left.replace('%',''));
			var center_class = this.settings.info_window_position_class_root;
			
			if (center_left < 35) {
				center_class = center_class+'left';
			}
			else if (center_left < 65) {
				center_class = center_class+'center'
			}
			else {
				center_class = center_class+'right'
			}
			
			if (center_top < 50) {
				center_class = center_class+'--top'
			}
			else {
				center_class = center_class+'--bottom'
			}
			
			return center_class;
			
		}
	};
	
	var $selects = $(".js-download-list__select");
	
	// function SaveToDisk(fileURL, fileName) {
	//     if (!window.ActiveXObject) { // for non-IE
	//         var save = document.createElement('a');
	//         save.href = fileURL;
	//         save.target = '_blank';
	//         save.download = fileName || 'unknown';
	//
	//         try {
	//             var evt = new MouseEvent('click', {
	//                 'view': window,
	//                 'bubbles': true,
	//                 'cancelable': false
	//             });
	//             save.dispatchEvent(evt);
	//
	//             (window.URL || window.webkitURL).revokeObjectURL(save.href);
	//         } catch (e) { // fallback
	//             window.open(fileURL, fileName);
	//         }
	//     } else if (!!window.ActiveXObject && document.execCommand) { // for IE < 11
	//         var _window = window.open(fileURL, '_blank');
	//         _window.document.close();
	//         _window.document.execCommand('SaveAs', true, fileName || fileURL);
	//         _window.close();
	//     }
	// }
	
	if ($selects.length) {
		var $downloadFrame = $('<iframe style="display:none"></iframe>');
		$("body").append($downloadFrame);
	
		$selects.niceSelect();
	
		// the base logic for the download select is in templates\src\assets\web\bower\jquery-nice-select\js\jquery.nice-select.js
	
		// loop over all selects
		$selects.each(function () {
			// the select is the current select in the loop
			const $select = $(this);
			const index = $selects.index($select);
	
			// the list trigger is the next element after the select
			const listTrigger = $select.next();
			// the list is the ul element inside the list trigger
			const list = listTrigger.find("ul");
			// the clickable elements are the li elements inside the list without disabled class
			const listElements = list.find("li:not(.disabled)");
	
			const selectName = $select.attr("name") || "";
	
			// add it to list
			list.attr(
				"id",
				"nice-select-list-download-" + sanitizeId(selectName) + index
			);
	
			// add a11y attributes
			listTrigger.attr("role", "combobox");
			listTrigger.attr("aria-owns", list.attr("id"));
			listTrigger.attr("aria-expanded", "false");
			listTrigger.attr("aria-haspopup", "listbox");
			list.attr("role", "listbox");
			list.attr("inert", "");
			listElements.attr("role", "option");
			listElements.attr("tabindex", "0");
	
			// take over aria-labels and and descriptions from original select
			listTrigger.attr("aria-label", $select.attr("aria-label"));
			listTrigger.attr("aria-labelledby", $select.attr("aria-labelledby"));
			listTrigger.attr("aria-description", $select.attr("aria-description"));
			listTrigger.attr("aria-describedby", $select.attr("aria-describedby"));
	
			// on button click toggle aria-expanded and list aria-hidden
			listTrigger.on("click", function () {
				var expanded =
					listTrigger.attr("aria-expanded") === "true" ? "false" : "true";
				listTrigger.attr("aria-expanded", expanded);
				// remove inert if expanded
				if (expanded === "true") {
					list.removeAttr("inert");
				} else {
					list.attr("inert", "");
				}
			});
		});
	
		$selects.on("change", function () {
			var $t = $(this);
			var val = $(this).val();
			$t.val("-");
			$t.find("option:first-child").attr("selected", "selected");
	
			var $disabledOption = $t.find("option[value='-']");
			var disabledOptionText = $disabledOption.text().trim();
	
			var $listTrigger = $t.next();
			var $current = $listTrigger.find(".current");
	
			// prevent the current text from updating to the selected value
			$current.text(disabledOptionText);
	
			var name = val.split("/");
			name = name[name.length - 1];
			// SaveToDisk(val, name);
	
			// $downloadFrame.attr('src', val);
	
			var url = val;
			if (url.indexOf("http") < 0)
				url = window.location.protocol + "//" + window.location.host + "/" + val;
	
			val = url;
			window.open(val, name);
		});
	}
	
	function contactForm($el) {
		this.$el = $el;
		this.$success = $(this.classes.success, $el);
		this.$error = $(this.classes.error, $el);
		this.$button = $(this.classes.button, $el);
	
		this.action = $el.attr('action');
		this.method = $el.attr('method');
	
		this.init();
	};
	contactForm.prototype = {
	
		classes: {
			success: '.js-contact-form-success',
			error: '.js-contact-form-error',
			button: '.js-contact-form-button',
		},
	
		init: function() {
			this.addListeners();
		},
	
		addListeners: function() {
			this.$el.on('submit', {self: this}, this.formSubmitHandler);
		},
	
		formSubmitHandler: function(e) {
			e.preventDefault();
			var t = e.data.self;
			t.submitForm();
		},
	
		submitForm: function(){
			var t = this;
	
			Main.objects.preloader.showPreloader(t.$button);
	
			var formData = this.$el.serialize();
			var data = {
				topic: window.form.topic.join(', '),
				center: window.form.center.join(', '),
				message: $('[name="message"]').val(),
				first_name: $('[name="first_name"]').val(),
				last_name: $('[name="last_name"]').val(),
				salutation: $('[name="salutation"]').val(),
				company: $('[name="company"]').val(),
				contact_person: $('[name="contact_person"]').val(),
				page: $('[name="page"]').val(),
				email: $('[name="email"]').val(),
				phone: $('[name="phone"]').val(),
				recipient_id: $('[name="recipient_id"]').val(),
				privacy: $('[name="privacy"]').prop('checked') ? 1 : undefined,
				mycfr: $('[name="mycfr"]').val(),
				recaptcha: this.$el.find('[name=g-recaptcha-response]').val()
			};
	
			$.ajax({
				url: t.action,
				method: t.method,
				data: data,
			}).done(function(response){
				$('.haserror').removeClass('haserror');
				if(typeof response.errors !== 'undefined' && Object.keys(response.errors).length > 0){
					// $.map(response.errors['errors'].missing_data, function(item) {
					// 	$('[name="' + item + '"]').addClass('haserror');
					// })
					var x = response.errors;
					Object.keys(x).forEach(function (k) {
						Object.keys(response.errors[k]).forEach(function (ik) {
							if(ik == 'recaptcha'){
								$('.js-recaptcha').addClass('haserror');
							} else {
								$('[name="' + ik + '"]').addClass('haserror');
							}
						})
					});
				} else {
					// t.$el.find('input, textarea').not('input[type="hidden"]').val('');
					$('.js-contact-form-success').css({
						display: 'block',
						opacity: 1
					});
					$('.contact-form__filters').addClass('form_disabled')
					$('.contact-form__fields').addClass('form_disabled')
					$('.contact-form__button').addClass('form_disabled')
				}
				Main.objects.preloader.hidePreloader(t.$button);
			});
		},
	
		showMessage: function(type){
			this.$error.hide();
			this.$success.hide();
			var $message;
			if(type === 'error'){
				$message = this.$error;
			} else {
				$message = this.$success;
			}
	
			TweenLite.to($message, 0.5, {
				opacity: 1,
				display: 'block',
			});
	
		},
	
	};
	
	var cookieHeader = function($el) {
		this.$el = $el;
	
		this.init();
	};
	
	cookieHeader.prototype = {
		init: function() {
			var context = this;
	
			if(Cookies.get('ses_european_cookies_accepted') == 1){
				this.startTracking();
			} else {
				context.$el.show();
	
				context.updatePadding();
	
				$(window).on('resize.cookie-header', function(){
					context.updatePadding();
				});
	
				context.$el.on('click', '.js-cookie-header-close', function(e){
					e.preventDefault();
	
					Cookies.set('ses_european_cookies_accepted', '1', {expires: 365});
	
					$(document).trigger('cookieheaderhide');
					$(window).off('resize.cookie-header');
	
					context.startTracking();
	
					$('body').animate({
						marginBottom: 0,
					}, {
						duration: 500,
					});
	
					context.$el.addClass('is-accepted');
				});
			}
		},
	
		startTracking: function(){
			console.log('start tracking');
		},
	
		updatePadding: function(){
			$('body').css({
				marginBottom: this.$el.outerHeight(),
			});
		},
	};
	
	function portfolioMap($el) {
	    this.$el = $el;
	
	    this.classes = {
	        canvas: '.js-portfolioMap-canvas',
	        zoomIn: '.js-portfolioMap-zoomin',
	        zoomOut: '.js-portfolioMap-zoomout',
	    };
	
	    this.$canvas             = $el.find(this.classes.canvas);
	    this.map                 = undefined;
	    this.mapConfig            = this.$canvas.attr('data-map-config') ? JSON.parse(this.$canvas.attr('data-map-config')) : false;
	    this.highlighted_country = this.$canvas.attr('data-highlighted-country') ? JSON.parse(this.$canvas.attr('data-highlighted-country')) : false;
	    this.list                = this.$canvas.attr('data-list') ? JSON.parse(this.$canvas.attr('data-list')) : false;
	
	    this.googleMapLoaded = false;
	
	    this.mapStyle = [
	      {
	        "elementType": "geometry",
	        "stylers": [
	          {
	            "color": this.highlighted_country ? "#e8e8e8" : "#f7f7f7"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative",
	        "elementType": "geometry",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.country",
	        "stylers": [
	          {
	            "visibility": "on"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.country",
	        "elementType": "geometry.stroke",
	        "stylers": [
	          {
	            "color": "#d4d4d4"
	          },
	          {
	            "visibility": "on"
	          },
	          {
	            "weight": 2
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.country",
	        "elementType": "labels",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.land_parcel",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.locality",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.neighborhood",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.province",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "poi",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "poi",
	        "elementType": "geometry",
	        "stylers": [
	          {
	            "color": "#eeeeee"
	          }
	        ]
	      },
	      {
	        "featureType": "poi",
	        "elementType": "labels.text.fill",
	        "stylers": [
	          {
	            "color": "#757575"
	          }
	        ]
	      },
	      {
	        "featureType": "road",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "transit",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "water",
	        "elementType": "geometry",
	        "stylers": [
	          {
	            "color": "#c9c9c9"
	          }
	        ]
	      },
	      {
	        "featureType": "water",
	        "elementType": "geometry.fill",
	        "stylers": [
	          {
	            "color": this.highlighted_country ? "#dadada" : "#e0e0e0"
	          }
	        ]
	      }
	    ];
	
	    this.mapStyleDetailed = [
	      {
	        "elementType": "geometry",
	        "stylers": [
	          {
	            "color": this.highlighted_country ? "#e8e8e8" : "#f7f7f7"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative",
	        "elementType": "geometry",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.country",
	        "stylers": [
	          {
	            "visibility": "on"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.country",
	        "elementType": "geometry.stroke",
	        "stylers": [
	          {
	            "color": "#d4d4d4"
	          },
	          {
	            "visibility": "on"
	          },
	          {
	            "weight": 2
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.country",
	        "elementType": "labels",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.land_parcel",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.locality",
	        "stylers": [
	          {
	            "visibility": "simplified"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.neighborhood",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.province",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "administrative.province",
	        "elementType": "geometry.stroke",
	        "stylers": [
	          {
	            "color": "#9e9e9e"
	          },
	          {
	            "visibility": "on"
	          }
	        ]
	      },
	      {
	        "featureType": "poi",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "poi",
	        "elementType": "geometry",
	        "stylers": [
	          {
	            "color": "#eeeeee"
	          }
	        ]
	      },
	      {
	        "featureType": "poi",
	        "elementType": "labels.text.fill",
	        "stylers": [
	          {
	            "color": "#757575"
	          }
	        ]
	      },
	      {
	        "featureType": "road",
	        "stylers": [
	          {
	            "visibility": "simplified"
	          }
	        ]
	      },
	      {
	        "featureType": "road",
	        "elementType": "geometry.fill",
	        "stylers": [
	          {
	            "color": "#ffffff"
	          }
	        ]
	      },
	      {
	        "featureType": "road.highway",
	        "elementType": "labels.icon",
	        "stylers": [
	          {
	            "saturation": -100
	          },
	          {
	            "lightness": 55
	          }
	        ]
	      },
	      {
	        "featureType": "road.local",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "transit",
	        "stylers": [
	          {
	            "visibility": "off"
	          }
	        ]
	      },
	      {
	        "featureType": "water",
	        "elementType": "geometry",
	        "stylers": [
	          {
	            "color": "#c9c9c9"
	          }
	        ]
	      },
	      {
	        "featureType": "water",
	        "elementType": "geometry.fill",
	        "stylers": [
	          {
	            "color": this.highlighted_country ? "#dadada" : "#e0e0e0"
	          }
	        ]
	      }
	    ];
	
	    this.infowindow = undefined;
	    this.is_infowindow_active = false;
	
	    this.pinSizes = {
	        shopping_street : [17, 21],
	        shopping_mall   : [17, 21],
	        retail_park     : [17, 21],
	        hypermarket_mall: [14, 18],
	        project         : [19, 21],
	        city            : [5, 5],
	    };
	
	    this.pinSizesDetailed = {
	        shopping_street : [25, 31],
	        shopping_mall   : [25, 31],
	        retail_park     : [25, 31],
	        hypermarket_mall: [20, 26],
	        project         : [28, 31],
	        city            : [10, 10],
	    };
	
	    this.clusterPriority = {
	        shopping_mall   : 50,
	        hypermarket_mall: 60,
	        shopping_street : 30,
	        retail_park     : 20,
	        project         : 10,
	    };
	
	    this.pinPriority = {
	        shopping_mall   : 50,
	        hypermarket_mall: 40,
	        shopping_street : 30,
	        retail_park     : 20,
	        project         : 10,
	    };
	
	    this.clusterGroups = {
	        shopping_mall   : 'shopping_mall',
	        hypermarket_mall: 'hypermarket_mall',
	        shopping_street : 'shopping_mall',
	        retail_park     : 'shopping_mall',
	        project         : 'shopping_mall',
	    };
	
	    this.markers = {
	        cities: [],
	    };
	
	    this.markerClusters = {};
	
	    this.markerIds = [];
	
	    this.init();
	};
	
	portfolioMap.prototype = {
	    constructor: portfolioMap,
	
	    initListeners: function() {
	
	        $(document).on('click', {
				self: this
	        }, this.documentClickHandler);
	
	        $(document).on('click', '.portfolioMap__info--scroll', this.infoWindowClickHandler);
	
	        this.$el.on('filter', {
	            self: this
	        }, this.onElementFilterHandler);
	
	      var that = this;
	      $(this.classes.zoomIn).on('click', function(){
	        if(!$(this).hasClass('disabled')){
	          that.map.setZoom(that.map.getZoom() + 1);
	        }
	      });
	      $(this.classes.zoomOut).on('click', function(){
	        if(!$(this).hasClass('disabled')){
	          that.map.setZoom(that.map.getZoom() - 1);
	        }
	      });
	
	    },
	
	    checkLegendSmallprint: function() {
	
	      if($('.js-center-list-form select[name="category[]"] option[value="hypermarket_mall"]').is(':selected') || $('.js-center-list-form select[name="category[]"] option:selected').length === 0){
	        $('.portfolioMap__legend__footnote').show(0);
	      } else {
	        $('.portfolioMap__legend__footnote').hide(0);
	      }
	
	    },
	
	    checkZoom: function(){
	      if(this.map.getZoom() > 7 && this.map.getZoom() < 14){
	        $(this.classes.zoomOut).removeClass('disabled');
	        $(this.classes.zoomIn).removeClass('disabled');
	      } else if(this.map.getZoom() == 7){
	        $(this.classes.zoomOut).addClass('disabled');
	      } else if(this.map.getZoom() == 14){
	        $(this.classes.zoomIn).addClass('disabled');
	      }
	    },
	
	    infoWindowClickHandler: function (event) {
	
	      var id = $(this).attr('data-scroll-id');
	      var $table_row = $('.js-hypermarkets [data-type="hypermarket_mall"][data-id="' + id + '"]');
	
	      if($table_row.length){
	        $('html, body').animate({
	          scrollTop: $table_row.offset().top - 200
	        }, 1000);
	
	        // Highlight table row for two seconds
	        $table_row.addClass('highlight');
	
	        setTimeout(function(){
	          $table_row.removeClass('highlight');
	        }, 4000);
	      }
	    },
	
	    documentClickHandler: function(event) {
			var self = event.data.self;
	        if (self.is_infowindow_active) {
	            self.infowindow.close();
	            self.is_infowindow_active = false;
	        }
	    },
	
	    onElementFilterHandler: function(event, data){
	        var self = event.data.self;
	
	        self.checkLegendSmallprint();
	
	        self.showMarkers(data.ids);
	        if(typeof data.show_hypermarket_mall_in_legend !== 'undefined'){
	          self.toggleHyperMarketMallLegend(data.show_hypermarket_mall_in_legend);
	        }
	    },
	
	    toggleHyperMarketMallLegend: function (status) {
	      if(status === true){
	        $('[data-legend-item-type="hypermarket_mall"]').show();
	      } else {
	        $('[data-legend-item-type="hypermarket_mall"]').hide();
	      }
	    },
	
	    drawMarkers: function () {
	        var self = this;
	        var zoom = this.map.getZoom();
	        var currentPinSizes = zoom > 8 ? this.pinSizesDetailed : this.pinSizes;
	
	        if(this.list && this.list.groups){
	            this.list.groups.forEach(function(group, index){
	                if(!self.markers.hasOwnProperty(self.clusterGroups[group.type])){
	                    self.markers[self.clusterGroups[group.type]] = {};
	                }
	                if(group.items){
	                    group.items.forEach(function (item, index) {
	
	                        // prevent the same pin multiple times on the map
	                        if(self.markerIds.includes(item.id)){
	                          return;
	                        }
	
	                        self.markerIds.push(item.id);
	
	                        var states = '';
	                        if(item.hasOwnProperty('state') && item.state.hasOwnProperty('title')){
	                          states = item.state.title;
	                        } else if(item.hasOwnProperty('state')){
	                          item.state.forEach(function(k,i){
	                              states = states + k.title + ', ';
	                          });
	                          states = states.substr(0, states.length-2);
	                        }
	
	                        var marker = new google.maps.Marker({
	                            id: item.id,
	                            position: { lat: parseFloat(item.coordinates.lat), lng: parseFloat(item.coordinates.lng) },
	                            zIndex     : google.maps.Marker.MAX_ZINDEX + self.pinPriority[group.type],
	                            icon: {
	                                url: self.mapConfig.marker_path + 'pin-' + item.type + '.svg', // url
	                                scaledSize: currentPinSizes[item.type] ? new google.maps.Size(currentPinSizes[item.type][0], currentPinSizes[item.type][1]) : new google.maps.Size(17, 21),
	                            },
	                            data: {
	                                id: item.id,
	                                name: item.name,
	                                city: item.city,
	                                country: item.country.title,
	                                size: item.size_text,
	                                size_add: item.size_text_add,
	                                thumbnail: item.thumbnail.url,
	                                url: item.link && item.link.url ? item.link.url : false,
	                                state: states,
	                                itemType: item.type,
	                                detaillink: item.neighbourhoodcenter_detail_page
	                            }
	                        });
	
	                        marker.addListener("mouseover", function(){
	                            self.infowindow.setContent(
	                                (marker.data.url && (marker.data.itemType !== 'hypermarket_mall' || marker.data.detaillink === true) ? '<a href="' + marker.data.url + '" target="_blank" class="portfolioMap__info">' : '<div class="portfolioMap__info portfolioMap__info--scroll" data-scroll-id="' + marker.data.id + '">') +
	                                    '<div class="portfolioMap__info__close">' +
	                                        '<div class="portfolioMap__info__close__icon icon icon--plus"></div>' +
	                                    '</div>' +
	                                    (marker.data.thumbnail ?
	                                    '<div class="portfolioMap__info__thumbnail">'+
	                                        '<img src="' + marker.data.thumbnail + '">' +
	                                    '</div>' : '') +
	                                    '<div class="portfolioMap__info__meta">' +
	                                        '<div class="portfolioMap__info__title">' + marker.data.name + '</div>' +
	                                        '<div class="portfolioMap__info__text">' +
	                                            '<p>' +
	                                                (marker.data.city ? marker.data.city + ', ' : '') + (marker.data.country ? marker.data.country : '') + ((marker.data.city || marker.data.country) && marker.data.size ? '<br/>' : '') +
	                                                (marker.data.size ? 'GLA: ' + marker.data.size + ' m²' : '') +
	                                                (marker.data.size_add ? '<br />' + marker.data.size_add : '') +
	                                                (marker.data.state ? '<br /><span class="state">' + marker.data.state + '</span>' : '') +
	                                            '</p>' +
	                                        '</div>' +
	                                    '</div>' +
	                                    (marker.data.url && marker.data.itemType !== 'hypermarket_mall' ? '</a>' : '</div>')
	                            );
	                            self.infowindow.open(self.map, marker);
	                            self.is_infowindow_active = true;
	                        });
	
	                        if(!self.markers[self.clusterGroups[group.type]].hasOwnProperty(item.subcluster)){
	                          self.markers[self.clusterGroups[group.type]][item.subcluster] = [];
	                        }
	
	                        self.markers[self.clusterGroups[group.type]][item.subcluster].push(marker);
	
	                    });
	                }
	            });
	        }
	
	        self.markerIds = [];
	    },
	
	    undrawCities: function () {
	      if(this.markers.cities){
	        for (var marker in this.markers.cities) {
	          this.markers.cities[marker].setMap(null);
	        }
	        this.markers.cities = [];
	      }
	    },
	
	    drawCities: function () {
	        var self = this;
	
	        if(this.mapConfig.cities){
	            this.mapConfig.cities.forEach(function (city, index) {
	
	                var marker = new google.maps.Marker({
	                    position: { lat: parseFloat(city.coordinates.lat), lng: parseFloat(city.coordinates.lng) },
	                    map: self.map,
	                    zIndex: 1,
	                    label: {
	                        text: city.name,
	                        fontSize: "12px",
	                    },
	                    icon: {
	                        url        : self.mapConfig.marker_path + (city.capital ? 'pin-city-capital.svg' : 'pin-city.svg'),
	                        scaledSize : new google.maps.Size(self.pinSizes.city[0], self.pinSizes.city[1]),
	                        labelOrigin: city.label_position == 'bottom' ? new google.maps.Point(7, 15) : new google.maps.Point(7, -10),
	                        origin     : new google.maps.Point(0,0),
	                        anchor     : new google.maps.Point(0, 0)
	                    },
	                });
	
	                self.markers.cities.push(marker);
	
	            });
	        }
	    },
	
	    highlightCountry: function () {
	        if(this.highlighted_country){
	            var polygon = new google.maps.Polygon({
	                paths: this.highlighted_country,
	                strokeColor: '#97C00E',
	                strokeOpacity: 0.75,
	                strokeWeight: 2,
	                fillColor: '#FFFFFF',
	                fillOpacity: 0.4
	            });
	            polygon.setMap(this.map);
	        }
	    },
	
	    initMap: function () {
	
	        var self = this;
	
	        this.map = new google.maps.Map(this.$canvas[0], {
	            center: { lat: parseFloat(this.mapConfig.center.lat), lng: parseFloat(this.mapConfig.center.lng) },
	            zoom: parseFloat(this.mapConfig.zoom),
	            styles: this.mapStyle,
	            disableDefaultUI: true,
	        });
	
	        this.map.addListener("zoom_changed", function() {
	          var zoom = self.map.getZoom();
	
	          if(zoom > 8){
	            self.map.setOptions({styles: self.mapStyleDetailed});
	            self.undrawCities();
	          } else {
	            self.map.setOptions({styles: self.mapStyle});
	
	            if(self.markers.cities.length <=0 ){
	              self.drawCities();
	            }
	          }
	          self.checkZoom();
	
	          self.resizeMarkers();
	        });
	
	        this.initInfobox();
	        this.highlightCountry();
	        this.drawCities();
	        this.drawMarkers();
	        this.initClusters();
	    },
	
	    initInfobox: function () {
	        this.infowindow = new google.maps.InfoWindow({
	            content               : '',
	            alignBottom           : true,
	            disableAutoPan        : false,
	            pixelOffset           : new google.maps.Size(-165, 20),
	            enableEventPropagation: false,
	        });
	    },
	
	    resizeMarkers: function () {
	      var self = this;
	      var zoom = this.map.getZoom();
	      var currentPinSizes = zoom > 9 ? this.pinSizesDetailed : this.pinSizes;
	
	      if(this.markers){
	        for (var property in this.markers) {
	          if (property !== 'cities' && this.markers.hasOwnProperty(property)) {
	            if(this.markers[property]){
	              for (var subcluster in this.markers[property]) {
	                this.markers[property][subcluster].forEach(function name(marker, index) {
	                  self.markers[property][subcluster][index].setIcon({
	                    url: self.mapConfig.marker_path + 'pin-' + self.markers[property][subcluster][index].data.itemType + '.svg', // url
	                    scaledSize: currentPinSizes[self.markers[property][subcluster][index].data.itemType] ? new google.maps.Size(currentPinSizes[self.markers[property][subcluster][index].data.itemType][0], currentPinSizes[self.markers[property][subcluster][index].data.itemType][1]) : new google.maps.Size(17, 21),
	                  });
	                });
	              }
	            }
	          }
	        }
	      }
	    },
	
	    initClusters: function () {
	        if(this.markers){
	            for (var property in this.markers) {
	                if (property !== 'cities' && this.markers.hasOwnProperty(property)) {
	                  for (var subcluster in this.markers[property]) {
	
	                    if(!this.markerClusters.hasOwnProperty(property)){
	                      this.markerClusters[property] = {};
	                    }
	
	                    this.markerClusters[property][subcluster] = new MarkerClusterer(this.map, this.markers[property][subcluster], {
	                        // gridSize: 30,
	                        maxZoom: 9,
	                        averageCenter: true,
	                        zoomOnClick: false,
	                        styles: [
	                            {
	                                url        : this.mapConfig.marker_path + 'cluster-' + property + '.svg?v=1',
	                                fontFamiliy: 'Roboto, Arial, sans-serif',
	                                fontWeight : 'bold',
	                                textColor  : property == 'hypermarket_mall' ? '#4C4C4C' : '#FFFFFF',
	                                textSize   : property == 'hypermarket_mall' ? 12 : (property == 'project' ? 10 : 14),
	                                width      : 34,
	                                height     : 34,
	                                anchorIcon : property == 'hypermarket_mall' ? [34, 40] : [34, 25],
	                                anchorText : property == 'hypermarket_mall' || property == 'project' ? [7, window.document.documentMode ? 0 : 17] : [6, window.document.documentMode ? 0 : 17],
	                                zIndex     : google.maps.Marker.MAX_ZINDEX + this.clusterPriority[property],
	                            }
	                        ]
	                    });
	
	                    var self = this;
	
	                    google.maps.event.addListener(this.markerClusters[property][subcluster], 'clusterclick', function(cluster){
	                      self.map.setCenter(cluster.getCenter());
	                      self.map.setZoom(12);
	                    });
	                  }
	                }
	            }
	        }
	
	    },
	
	    init: function() {
	        this.initListeners();
	        this.initMap();
	    },
	
	    showMarkers: function (ids) {
	        var self = this;
	
	        if(this.markers && typeof ids !== 'undefined'){
	          for (var property in this.markers) {
	            if (property !== 'cities' && this.markers.hasOwnProperty(property)) {
	              if(this.markers[property]){
	
	                for (var subcluster in this.markers[property]) {
	                  this.markerClusters[property][subcluster].clearMarkers();
	
	                  this.markers[property][subcluster].forEach(function name(marker, index) {
	                    if(ids.includes(marker.id)){
	                      self.markerClusters[property][subcluster].addMarker(self.markers[property][subcluster][index], false);
	                    } else {
	                      self.markerClusters[property][subcluster].removeMarker(self.markers[property][subcluster][index], false);
	                    }
	                  });
	                }
	
	              }
	            }
	          }
	        }
	    },
	
	};
	
	function portfolioList($el) {
	    this.$el = $el;
	
	    this.init();
	};
	
	portfolioList.prototype = {
	    constructor: portfolioList,
	
	    initListeners: function() {
	
	        this.$el.on('viewchange', this.changeView);
	        this.$el.on('reset', this.reset);
	        this.$el.on('filter', this.filterList);
	
	        $('.js-center-list').trigger('triggerchange');
	
	    },
	
	    changeView: function(e, data){
	
	        if(data.data == 'list'){
	            $('.js-gridview').hide(0);
	            $('.js-listview').show(0);
	        } else {
	            $('.js-gridview').show(0);
	            $('.js-listview').hide(0);
	        }
	
	    },
	
	    filterList: function(e, data){
	
	        var show_hypermarket_mall_in_legend = false;
	        var trigger_ids = new Array();
	
	        $('.js-list-wrapper').each(function(){
	
	            var $e = $(this);
	
	            $('.js-category-block', $e).hide(0);
	
	            // categories
	            if(typeof data['category[]'] == 'string'){
	                data['category[]'] = new Array(data['category[]']);
	            } else if(typeof data['category[]'] === 'undefined') data['category[]'] = new Array();
	    
	            data['category[]'].forEach(function(item){
	                $('.js-category-block[data-type=' + item + ']', $e).show(0);
	                if(item == 'hypermarket_mall'){
	                    show_hypermarket_mall_in_legend = true;
	                }
	            });
	            if(data['category[]'].length < 1){
	                $('.js-category-block', $e).show(0);
	                show_hypermarket_mall_in_legend = true;
	            }
	    
	            $('.js-category-block[data-type=project]', $e).show(0);
	    
	    
	            // state
	            if(typeof data['state[]'] == 'string'){
	                data['state[]'] = new Array(data['state[]']);
	            } else if(typeof data['state[]'] === 'undefined') data['state[]'] = new Array();
	
				var show_category_data = false;
				var show_project_data = false;
	
				if(typeof data['state[]'] === 'undefined' || data['state[]'] == ''){
					show_category_data = true;
					show_project_data = true;
				} else {
					var fulldata = JSON.parse($('[name="state[]"]').parent().attr('data-status'));
					for(var i=0; i<data['state[]'].length; i++){
						if(fulldata.hasOwnProperty(data['state[]'][i])){
		
							if(show_category_data === false && fulldata[data['state[]'][i]]['category_status'] == true) show_category_data = true;
							if(show_project_data === false && fulldata[data['state[]'][i]]['project_status'] == true) show_project_data = true;
		
						}
					}
				}
	    
	            // gallery/list
	            if(data.view == 'grid'){
	                $('.js-category-block.js-listview', $e).hide(0);
	            } else {
	                $('.js-category-block.js-gridview', $e).hide(0);
	            }
	    
	    
	            // check attributes
	            if(typeof data['country[]'] == 'string'){
	                data['country[]'] = new Array(data['country[]']);
	            } else if(typeof data['country[]'] === 'undefined') data['country[]'] = new Array();
	    
	            if(typeof data['size[]'] == 'string'){
	                data['size[]'] = new Array(data['size[]']);
	            } else if(typeof data['size[]'] === 'undefined') data['size[]'] = new Array();
	    
	            $('.js-category-block:visible .js-portfolio-element', $e).show(0); // show all first, remove by filter
	    
	            $('.js-category-block:visible .js-portfolio-element', $e).each(function(){
	    
	                if(data['country[]'].indexOf($(this).data('country')) < 0 && data['country[]'].length > 0){
	                    $(this).hide(0);
	                } else {
	    
	                    var center_states = $(this).data('state').split(',');
	                    center_states = center_states.filter(Boolean);
	    
	                    var state_passed = false;
	                    if(data['state[]'].length <= 0){
	                        state_passed = true;
	                    } else {
	                        center_states.forEach(function(item){
	                            if(data['state[]'].indexOf(item) >= 0){
	                                state_passed = true;
	                            }
	                        });
	                    }
	    
	                    if(!state_passed){
	                        $(this).hide(0);
	                    } else {
	                        if(data['size[]'].length > 0){
	                            var size = $(this).data('size');
	    
	                            if(size <= 10000 && data['size[]'].indexOf('up-to-10-000') < 0) $(this).hide();
	                            if(size > 10000 && size <= 15000 && data['size[]'].indexOf('small') < 0) $(this).hide();
	                            if(size > 15000 && size <= 30000 && data['size[]'].indexOf('mid') < 0) $(this).hide();
	                            if(size > 30000 && data['size[]'].indexOf('big') < 0) $(this).hide();
	                        }
	    
	                        if(data['state[]'].length > 0){
	                            if($(this).parents('.js-category-block').data('type') != 'project'){
	                                if(!state_passed){
	                                    $(this).hide();
	                                }
	                            }
	                        }
	                    }
	                }
	            });
	    
	    
	            // check categories of projects
	            $('.js-category-block[data-type=project] .js-portfolio-element', $e).each(function(){
	                if(data['category[]'].indexOf($(this).data('type')) < 0 && data['category[]'].length > 0){
	                    $(this).hide(0);
	                }
	            });
	    
	
				// check overall project/category
				if(!show_category_data) $('.js-category-block[data-hide-logic=category] .js-portfolio-element', $e).each(function(){ $(this).hide(0); });
				if(!show_project_data) $('.js-category-block[data-hide-logic=project] .js-portfolio-element', $e).each(function(){ $(this).hide(0); });
	
	
	            // hide if no element inside visible
	            $('.js-category-block', $e).each(function(){
	                if($(this).find('.js-portfolio-element:visible').length < 1){
	                    $(this).hide(0);
	                }
	            });
	
	
	            // trigger map repaint
	            $('.js-category-block:visible .js-portfolio-element:visible', $e).each(function(){
	                trigger_ids.push($(this).data('id'));
	            });
	    
	            // update result
	            var result = $('.js-filter-result', $e).data('result') + '<b>';
	            var result_count = 0;
	            $('.js-category-block:visible', $e).each(function(){
	
	                result_count++;
	
	                var overall_text = ($(this).attr('data-type-name-overall') != '-1') ? true : false;
	                if(overall_text) result += ' ' + $(this).attr('data-type-name-overall');
	                
	                result += ' ' + $(this).find('.js-portfolio-element:visible').length;
	                
	                if(overall_text) result += ',';
	                if(!overall_text){
	                    result += ' ';
	                    if($(this).find('.js-portfolio-element:visible').length == 1) result += $(this).attr('data-type-name-singular') + ',';
	                    else result += $(this).attr('data-type-name') + ',';
	                }
	                
	            });
	
	            if(result_count == 0){
	
	                result = $('.js-filter-result', $e).attr('data-no-result');
	
	            } else {
	                result = result.substr(0, result.length - 1);
	                var i = result.lastIndexOf(',');
	        
	                var part1 = result.substr(0, i);
	                var part2 = result.substr(i+1, result.length);
	        
	                result = (part1.length ? part1 + ' </b>' + $('.js-filter-result', $e).attr('data-translation-and') + '<b>' : '') + part2;
	        
	                result += '</b>.';
	            }
	            
	            $('.js-filter-result', $e).html(result);
	            
	        });
	
	        // sum up all data first
	        $('.js-portfolioMap').trigger('filter', [{ids: trigger_ids, show_hypermarket_mall_in_legend: show_hypermarket_mall_in_legend}]);
	
	    },
	
	    resetList: function(){
	        console.log('reset')
	    },
	
	    init: function() {
	        this.initListeners();
	    },
	
	};
	
	function portfolioTeaser($el) {
	    this.$el = $el;
	
	    this.$canvas                = $el.find('#teaser_map');
	    this.map                    = undefined;
	    this.marker_icon            = this.$canvas.attr('data-marker');
	    this.center_lat             = this.$canvas.attr('data-lat');
	    this.center_lng             = this.$canvas.attr('data-lng');
	
	    this.info_img               = this.$canvas.attr('data-info-img');
	    this.info_title             = this.$canvas.attr('data-info-title');
	    this.info_info              = this.$canvas.attr('data-info-info');
	
	    this.mapStyle = [
	        {
	          "elementType": "geometry",
	          "stylers": [
	            {
	              "color": "#f7f7f7"
	            }
	          ]
	        },
	        {
	          "featureType": "administrative",
	          "elementType": "geometry",
	          "stylers": [
	            {
	              "visibility": "off"
	            }
	          ]
	        },
	        {
	          "featureType": "administrative.country",
	          "stylers": [
	            {
	              "visibility": "on"
	            }
	          ]
	        },
	        {
	          "featureType": "administrative.country",
	          "elementType": "geometry.stroke",
	          "stylers": [
	            {
	              "color": "#d4d4d4"
	            },
	            {
	              "visibility": "on"
	            },
	            {
	              "weight": 2
	            }
	          ]
	        },
	        {
	          "featureType": "administrative.country",
	          "elementType": "labels",
	          "stylers": [
	            {
	              "visibility": "on"
	            }
	          ]
	        },
	        {
	          "featureType": "administrative.land_parcel",
	          "stylers": [
	            {
	              "visibility": "off"
	            }
	          ]
	        },
	        {
	          "featureType": "administrative.locality",
	          "stylers": [
	            {
	              "visibility": "on"
	            }
	          ]
	        },
	        {
	          "featureType": "administrative.neighborhood",
	          "stylers": [
	            {
	              "visibility": "off"
	            }
	          ]
	        },
	        {
	          "featureType": "administrative.province",
	          "stylers": [
	            {
	              "visibility": "off"
	            }
	          ]
	        },
	        {
	          "featureType": "poi",
	          "stylers": [
	            {
	              "visibility": "off"
	            }
	          ]
	        },
	        {
	          "featureType": "poi",
	          "elementType": "geometry",
	          "stylers": [
	            {
	              "color": "#eeeeee"
	            }
	          ]
	        },
	        {
	          "featureType": "poi",
	          "elementType": "labels.text.fill",
	          "stylers": [
	            {
	              "color": "#757575"
	            }
	          ]
	        },
	        {
	          "featureType": "road",
	          "stylers": [
	            {
	              "visibility": "off"
	            }
	          ]
	        },
	        {
	          "featureType": "transit",
	          "stylers": [
	            {
	              "visibility": "off"
	            }
	          ]
	        },
	        {
	          "featureType": "water",
	          "elementType": "geometry",
	          "stylers": [
	            {
	              "color": "#c9c9c9"
	            }
	          ]
	        },
	        {
	          "featureType": "water",
	          "elementType": "geometry.fill",
	          "stylers": [
	            {
	              "color": "#e0e0e0"
	            }
	          ]
	        }
	    ];
	
	    this.infowindow = undefined;
	    this.is_infowindow_active = false;
	
	    this.pinSizes = {
	        shopping_street : [17, 21],
	        shopping_mall   : [17, 21],
	        retail_park     : [17, 21],
	        hypermarket_mall: [14, 18],
	        project         : [19, 21],
	        city            : [14, 14],
	    };
	
	    this.init();
	};
	
	portfolioTeaser.prototype = {
	    constructor: portfolioTeaser,
	
	    initListeners: function() {
	        $(document).on('click', {
				self: this
	        }, this.documentClickHandler);
	    },
	
	    documentClickHandler: function(event) {
			var self = event.data.self;
	        if (self.is_infowindow_active) {
	            self.infowindow.close();
	            self.is_infowindow_active = false;
	        }
	    },
	
	    initMap: function () {
	
	        var that = this;
	
	        this.map = new google.maps.Map(this.$canvas[0], {
	            center: { lat: parseFloat(this.center_lat), lng: parseFloat(this.center_lng) },
	            zoom: 11,
	            styles: this.mapStyle,
	            disableDefaultUI: true,
	        });
	
	        this.marker = new google.maps.Marker({
	            position: { lat: parseFloat(this.center_lat), lng: parseFloat(this.center_lng) },
	            zIndex: 2,
	            icon: {
	                url: this.marker_icon,
	            },
	        });
	
	        this.infowindow = new google.maps.InfoWindow({
	            content               : '',
	            alignBottom           : true,
	            disableAutoPan        : false,
	            pixelOffset           : new google.maps.Size(-165, 67),
	            enableEventPropagation: false,
	        });
	
	        this.marker.addListener("mouseover", function(){
	            that.infowindow.setContent(
	                '<div class="portfolioMap__info">' +
	                    '<div class="portfolioMap__info__close">' +
	                        '<div class="portfolioMap__info__close__icon icon icon--plus"></div>' +
	                    '</div>' +
	                    '<div class="portfolioMap__info__thumbnail">'+
	                        '<img src="' + that.info_img + '">' +
	                    '</div>' +
	                    '<div class="portfolioMap__info__meta">' +
	                        '<div class="portfolioMap__info__title">' + that.info_title + '</div>' +
	                        '<div class="portfolioMap__info__text">' +
	                            '<p>' + that.info_info + '</p>' +
	                        '</div>' +
	                    '</div>' +
	                '</div>'
	            );
	            that.infowindow.open(that.map, that.marker);
	            that.is_infowindow_active = true;
	        });
	
	        this.marker.setMap(this.map);
	
	    },
	
	    init: function() {
	        this.initMap();
	        this.initListeners();
	    },
	
	};
	
	function careerFinder($el) {
		this.$el = $el;
	
		this.$job = $(this.classes.job, $el);
		this.$form = $(this.classes.form, $el);
		this.$search = $(this.classes.search, $el);
		this.$city = $(this.classes.city, $el);
		this.$officeType = $(this.classes.officeType, $el);
		this.$submit = $(this.classes.submit, $el);
	
		this.searchTimeout;
	
		this.init();
	};
	
	careerFinder.prototype = {
	
		classes: {
			job: '.js-career-finder-job',
			form: '.js-career-finder-form',
			search: '.js-career-finder-search',
			city: '.js-career-finder-city',
			officeType: '.js-career-finder-office-type',
			submit: '.js-career-finder-submit',
		},
	
		init: function() {
			this.addListeners();
		},
	
		addListeners: function() {
			var t = this;
			t.$el.on('keyup', t.classes.search, {t: t}, t.searchKeyupHandler);
			t.$el.on('change', t.classes.city, {t: t}, t.cityChangeHandler);
			t.$el.on('change', t.classes.officeType, {t: t}, t.officeTypeChangeHandler);
			t.$el.on('click', t.classes.submit, {t: t}, t.submitClickHandler);
		},
	
		searchKeyupHandler: function(e){
			var t = e.data.t;
	
			if(t.searchTimeout !== undefined){
				clearTimeout(t.searchTimeout);			
			}
			t.searchTimeout = setTimeout(function() {
				t.searchJobs();
				t.searchTimeout = undefined;
			}, 300);
		},
	
		cityChangeHandler: function(e){
			console.log('ddd')
			var t = e.data.t;
			t.searchJobs();
		},
	
		officeTypeChangeHandler: function(e){
			var t = e.data.t;
			t.searchJobs();
		},
	
		submitClickHandler: function(e){
			var t = e.data.t;
			t.searchJobs();
		},
	
		searchJobs: function(){
			var t = this;
			var search = t.$search.val();
			var city = t.$city.val();
			var officeTypes = t.getOfficeTypes();
	
			t.$job.each(function(){
				var $job = $(this);
				var jobData = $job.data();
				var show = true;
	
				if(search !== ''){
					if(  $job.filter(':contains('+ search +')').length > 0 ){
						show = true;
					} else {
						$job.hide();
						return true
					}
				}
	
				if(city !== null){
					var jobCity = jobData['city'].toUpperCase();
					if( $.inArray(jobCity, city) >= 0 ){
						show = true;
					} else {
						$job.hide();
						return true
					}
				}
	
				if(officeTypes.length){
					var jobOfficeType = jobData['officeType'];
					if( $.inArray(jobOfficeType, officeTypes) >= 0 ){
						show = true;
					} else {
						$job.hide();
						return true
					}
				}
	
	
				if(show){
					$job.show();
				}
	
			})
	
		},
	
		getOfficeTypes: function(){
			var t = this;
			var officeTypes = [];
			t.$officeType.each(function(){
				var $type = $(this);
				if($type.prop('checked')){
					officeTypes.push($type.attr('name'));
				}
			});
			return officeTypes;
		},
	
	};
	
	
	
	$.expr[":"].contains = $.expr.createPseudo(function(arg) {
		return function( elem ) {
			return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
		};
	});
	var iconGrid = function ($el) {
		this.$el = $el;
		this.$elements = $el.find(".icon-grid__item");
		this.init();
	};
	
	iconGrid.prototype = {
		openItem: function ($item) {
			$item.find("p").removeAttr("inert");
	
			$item.find("p").css({ height: "auto" });
			var h = $item.find("p").innerHeight();
			$item.find("p").css({ height: "0px" });
			$item.find("p").animate(
				{
					height: h + "px",
					opacity: "1",
				},
				200
			);
		},
	
		closeItem: function ($item) {
			$item.find("p").attr("inert", "true");
	
			$item.find("p").animate(
				{
					height: "0px",
					opacity: "0",
				},
				200
			);
		},
	
		init: function () {
			this.$elements.on(
				"mouseenter",
				function (e) {
					this.openItem($(e.currentTarget));
				}.bind(this)
			);
	
			this.$elements.on(
				"mouseleave",
				function (e) {
					this.closeItem($(e.currentTarget));
				}.bind(this)
			);
	
			this.$elements.on(
				"focus",
				function (e) {
					this.openItem($(e.currentTarget));
				}.bind(this)
			);
	
			this.$elements.on(
				"blur",
				function (e) {
					this.closeItem($(e.currentTarget));
				}.bind(this)
			);
		},
	};
	
	// window.$ = jQuery;

	var gotocontactform = function () {
		if ($('.contact-form').length && (window.location.hash === '#contactform' || window.location.hash === '#_contactform')) {
			$('html, body').animate({
				scrollTop: $('.contact-form').offset().top - 80
			})
		} else {
			if (window.location.hash.length) {
				var $id = false;
				if (window.location.hash.indexOf('nav_') !== -1) {
					$id = $('section[data-nav="' + window.location.hash.replace('#nav_', '') + '"]')
				} else {
					$id = $('#' + window.location.hash.replace('#_', '').replace('#', ''));
				}

				if ($id.length) {
					if ($id.length) {
						$('html, body').animate({
							scrollTop: $id.offset().top - 80
						})
					}
				}
			}
		}
	};

	gotocontactform();

	$('body').on('click', 'a[href*="#_"]', function () {
		gotocontactform();
	})

	$(window).on('hashchange', function () {
		gotocontactform();
	}).on('load', function () {
		gotocontactform();
	})

	$('a[caption]').each(function () {
		var href = $(this).attr('href');
		var caption = $(this).attr('caption');
		$(this).attr('href', href + '#' + caption);
	})

})(jQuery);
